/**
 * `hr` translations, for every locale.
 */
export const hr = {
  mn: {
      clBonus: {
        title: 'Ээлжийн бус чөлөөний урамшууллын өдөр',
        intro: 'Хүн бүрт жилд {{days}} өдрийн цалинтай ээлжийн бус чөлөө (CL) олгодог. Оны шилдэг ажилтанд тухайн жилд нэмэлт өдөр олгож болно. Цалин бодолтод тооцогдоно; чөлөөний үлдэгдлийг өөрчлөхгүй.',
        loadFailed: 'Урамшууллын өдрийг ачаалж чадсангүй',
        paidThisYear: '{{year}} онд цалинтай CL: {{days}} өдөр',
        none: 'Урамшууллын өдөр олгоогүй.',
        year: 'Он', extraDays: 'Нэмэлт өдөр', note: 'Тэмдэглэл', grantedBy: 'Олгосон',
        grant: 'Олгох', replace: 'Солих', revoke: 'Цуцлах',
        replaceConfirm: '{{year}} оны урамшууллыг солих уу?',
        revokeConfirm: '{{year}} оны урамшууллыг цуцлах уу? Тухайн жилийн CL дахин 3 өдөр болно.',
        saved: 'Урамшууллын өдөр хадгалагдлаа', revoked: 'Урамшууллын өдөр цуцлагдлаа',
        saveFailed: 'Хадгалж чадсангүй',
        badYear: '2000-2100 хоорондох он оруулна уу',
        badDays: '0-ээс их, 365-аас ихгүй өдөр оруулна уу',
        halfDays: 'Бүтэн эсвэл хагас өдрөөр оруулна уу',
      },
      hr: {
        orgTabDirectory: 'Лавлах', orgTabChart: 'Байгууллагын бүтэц', orgTabsLabel: 'Байгууллагын хэсгүүд', orgDirectoryEmpty: 'Ажилтан олдсонгүй', directoryLoadFailed: 'Ажилтны жагсаалтыг ачаалж чадсангүй. Түр хүлээгээд дахин оролдоно уу.', statusInactive: 'Идэвхгүй', orgStatsHeading: 'Компанийн үзүүлэлт', genderNotRecorded: 'Бүртгэгдээгүй', orgStatsLoadFailed: 'Компанийн тоон мэдээллийг ачаалж чадсангүй.', searchStaff: 'Ажилтан хайх',
        orgFilterShowing: 'Шүүлт: {{name}}', orgFilterCount: '{{total}}-аас {{count}} харагдаж байна', orgFilterClear: 'Шүүлтүүрийг арилгах', orgFilterNone: 'Энэ сонголтод ажилтан алга', orgFilterHint: 'Багийг эсвэл бүтээгдэхүүнийг дарж схемийг шүүнэ',
        name: 'Нэр', staffId: 'Ажилтны дугаар', staffIdField: 'Ажилтны дугаар (ID)', staffCode: 'Ажилтны код',
        supervisor: 'Шууд удирдлага', peer: 'Орлох ажилтан', team: 'Баг', workType: 'Ажлын төрөл',
        workCondition: 'Хөдөлмөрийн нөхцөл', position: 'Албан тушаал', positionMn: 'Албан тушаал (МН)', positionZh: 'Албан тушаал (ХЯ)',
        contractEnd: 'Гэрээ дуусах', phone: 'Утас', email: 'Ажлын и-мэйл', personalEmail: 'Хувийн и-мэйл',
        displayName: 'Дэлгэцийн нэр', firstName: 'Нэр', lastName: 'Овог', firstNameMn: 'Нэр (кирилл)', lastNameMn: 'Овог (кирилл)',
        office: 'Оффис', status: 'Төлөв', dob: 'Төрсөн огноо', gender: 'Хүйс', genderBlank: '—', genderMale: 'Эрэгтэй', genderFemale: 'Эмэгтэй', country: 'Улс', degree: 'Боловсрол', profession: 'Мэргэжил',
        emergencyName: 'Яаралтай үед холбоо барих', emergencyPhone: 'Яаралтай утас',
        specialNeeds: 'Тусгай хэрэгцээ', dependentChildren: 'Асрамжинд байгаа хүүхэд', workedSince: 'Ажилд орсон', fullTimeStart: 'Бүтэн цагийн эхлэл', monthsBefore: 'Ажилд орохоос өмнөх даатгалтай сар',
        workedSinceHelp: 'Ажлын эхний өдөр. Ажилд авах эсвэл дахин авахад ажлын хугацааны бүртгэл энэ өдрөөс нээгдэх ба ээлжийн амралт анх олгохын өмнөх зургаан сар үүнээс тоологдоно. Цалинд ажилд орсон огноо болж харагдаж, шинэ ажилтны нийгмийн даатгалын бүртгэлийн хүсэлтээр Хуулийн хэлтэст очих ба ажлын ойг үүнээс тоолно. Үүнийг засахад одоогийн ажлын хугацааны бүртгэлийн эхлэл хамт өөрчлөгдөнө.',
        fullTimeStartHelp: 'Бүтэн цагаар ажиллаж эхэлсэн өдөр; хоосон бол ажилд орсон огноог ашиглана. Ээлжийн амралтын ажилласан хугацаа болон богино хугацааны чөлөө, өвчний чөлөөний жилийн шинэчлэл үүнээс тоологдох ба цалин бүтэн цагийн ажилтны баярын өдрийг зөвхөн энэ өдрөөс хойш тооцно. Үүнийг засахад одоогийн ажлын хугацааны бүртгэлийн бүтэн цагийн эхлэл хамт өөрчлөгдөнө.',
        monthsBeforeHelp: 'Ажилд орохоос өмнө нийгмийн даатгал төлсөн сарын тоо. Ээлжийн амралтын шатлалыг эдгээр сар, 2026 оны 4-р сар хүртэл энд бүтэн цагаар ажилласан сар, мөн 2026 оны 5-р сараас хойш баталгаажсан цалингаас нийгмийн даатгал суутгасан сар бүрийг нэмж тогтооно; цалин нь хараахан баталгаажаагүй дууссан сарыг баталгаажих хүртэл тооцно. Өөр ямар ч тооцоо энэ талбарыг ашигладаггүй.',
        resignationDate: 'Ажлаас гарах огноо',
        resignationDateRequired: 'Идэвхгүй болгохын тулд ажлаас гарах огноог оруулна уу',
        fieldRequired: 'Заавал бөглөнө',
        workedSinceRequired: 'Идэвхтэй ажилтанд ажилд орсон огноог оруулна уу',
        finalPay: {
          title: 'Эцсийн цалин',
          hint: 'Энэ хүний эцсийн цалин, нөхөн олговор хэрхэн шийдэгдсэнийг сонгоод тайлбар бичнэ үү.',
          paid: 'Олгосон',
          next_payroll: 'Дараагийн эцсийн цалинтай хамт олгоно',
          owed: 'Олгоогүй: өгөх ёстой дүнг хадгална',
          other: 'Бусад: хэрхэн шийдэгдсэнийг тайлбарт бичнэ',
          comment: 'Тайлбар',
          required: 'Идэвхгүй болгохын тулд эцсийн цалингийн шийдвэрийг сонгож, тайлбар бичнэ үү',
        },
        reactivateUndoConfirm: '{{name}}-г өмнөх байдалд нь сэргээнэ: чөлөөний үлдэгдэл, ажлын хугацаа хэвээр үлдэж, ажлаас гарах огноо арилна. Энэ ажлын хугацаанд ажлаас гарах огноогоор цуцлагдсан чөлөө төлөгдсөн эсэхийн мэдээлэлтэйгээ хамт буцаж сэргэнэ. Чөлөөний төлбөр эсвэл ажлаас гарсны чөлөөний тооцоо бүртгэлтэй бол түүнийг хүчингүй болгох хүртэл хадгалахыг зөвшөөрөхгүй. Үргэлжлүүлэх үү?',
        reactivateRehireConfirm: '{{name}}-г {{date}}-аас дахин ажилд авна: шинэ ажлын хугацаа эхэлж, AL, CL, PSL тэгээс эхэлнэ. Үргэлжлүүлэх үү?',
        reactivateRestored: 'Сэргээсэн чөлөөний хүсэлт: {{count}}',
        undoRefusedPayout: 'Чөлөөг сэргээх боломжгүй: {{status}} төлөвтэй чөлөөний төлбөр тооцооны хаалт ({{date}}) бүртгэлтэй байна. Эхлээд түүнийг хүчингүй болгоно уу. Төлбөр аль хэдийн хийгдсэн бол шинэ эхлэх огноотой дахин ажилд авна уу.',
        undoRefusedSettlement: 'Чөлөөг сэргээх боломжгүй: нөхцөлт {{status}} төлөвтэй, {{days}} өдрийн ажлаас гарах чөлөөний тооцоо бүртгэлтэй байна. Эхлээд түүнийг татгалзана уу. Төлбөр аль хэдийн хийгдсэн бол шинэ эхлэх огноотой дахин ажилд авна уу.',
        undoRefusedPaidOff: 'Чөлөөг сэргээх боломжгүй: идэвхгүй болгосны дараа чөлөөг төлж дууссан гэж тэмдэглэсэн ({{note}}). Эхлээд үлдэгдлийг гараар засна уу. Төлбөр аль хэдийн хийгдсэн бол шинэ эхлэх огноотой дахин ажилд авна уу.',
        reactivateNotRestored: 'Эдгээр цуцлагдсан чөлөө дараа нь бүртгэсэн өөр чөлөөтэй давхцаж байгаа тул цуцлагдсан хэвээр үлдлээ. Шалгаад шаардлагатай бол гараар дахин бүртгэнэ үү: {{list}}',
        deactivateWarnTitle: 'Хадгалснаар {{name}}-н бүртгэлээс гадна өөр зүйлс өөрчлөгдөнө. Үргэлжлүүлэхээсээ өмнө уншина уу.',
        deactivateWarnSignIn: '• Нэвтрэх эрх: хэрэв байгаа бол хаагдана. Ажлаас гарах огнооноос хойш 90 хоногийн турш зөвхөн өөрийн цалингийн хуудсаа үзэх боломжтой, дараа нь бүрэн хаагдана.',
        deactivateWarnRoster: '• Ээлжийн хуваарь: ажлаас гарсан гэж харагдах ба хуваарьт дахин нэмэх боломжгүй болно.',
        deactivateWarnLeave: '• Чөлөө: {{date}}-ээс хойш эхлэх бүх чөлөөний хүсэлт, хүлээгдэж буйг оролцуулан, цуцлагдана. Цалингаар аль хэдийн төлөгдсөн ээлжийн амралт хамаарахгүй. Батлагдсан өдрүүд үлдэгдэлд буцаж орно.',
        deactivateWarnUndo: 'Ижил ажилд орсон огноотойгоор дахин идэвхжүүлбэл буцаана: нэвтрэх эрх, ээлжийн хуваарь, мөн энэ ажлын хугацаанд цуцлагдсан чөлөө (төлөгдсөн эсэхийн мэдээлэл, чөлөөний дүрмийн давалттай нь) сэргэнэ. Дараа нь өөрчлөгдсөн эсвэл өөр чөлөөтэй давхцсан чөлөө сэргэхгүй. Чөлөөний төлбөр эсвэл ажлаас гарсны чөлөөний тооцоо бүртгэгдсэн бол түүнийг хүчингүй болгох хүртэл буцаах боломжгүй. Шинэ огноотой бол дахин ажилд авсанд тооцогдож AL, CL, PSL тэгээс эхэлнэ.',
        deactivateWarnDateOnly: 'Энэ огноог хойшлуулах эсвэл арилгах нь цуцлагдсан чөлөөг сэргээхгүй: гараар дахин бүртгэх шаардлагатай.',
        formerEmployee: '(ажлаас гарсан ажилтан)',
        sectionPersonal: 'Хувийн мэдээлэл', sectionJob: 'Ажил', sectionContact: 'Холбоо барих', sectionOther: 'Бусад',
        attachLogin: 'Нэвтрэх эрхтэй холбох', attachLoginNone: 'Шинэ бүртгэл (холбохгүй)', attachLoginHint: 'Нууц үгээр нэвтэрдэг, Microsoft-той холбогдоогүй, ажилтны бүртгэлгүй эрхүүд. Холбовол и-мэйл шаардахгүй.', sameNameWarning: 'Ижил нэртэй хүн бүртгэлд байна: {{names}}. Давхардуулж байгаа эсэхээ шалгана уу.',
        leaverTitle: 'Та ажлаас гарсан байна',
        leaverBody: 'Таны ажлын гэрээ дууссан тул энэ бүртгэлээр зөвхөн өөрийн цалингийн хуудсаа үзэх боломжтой. Энэ хандалт ажлаас гарсан өдрөөс хойш 90 хоногийн дараа хаагдана — хэрэгтэй хуудсаа татаж авна уу. Таны мэдээлэл устгагдаагүй: хүний нөөц болон нягтлан бодох хэсэг үүнийг хугацаагүй үзэх боломжтой хэвээр байна.',
        leaverSignedInAs: '{{email}}-ээр нэвтэрсэн',
        personalDataHidden: 'Нуугдсан: архивлагдсан бүртгэл',
        employeeLoadFailed: 'Ажилтны бүртгэлийг ачаалж чадсангүй',
        extrasHidden: 'Нуугдсан: Хувийн бүртгэлийн нэмэлт эрх шаардлагатай',
        erasePii: 'Хувийн мэдээллийг устгах', erasePiiConfirm: 'Энэ хүний утас, төрсөн огноо, хувийн и-мэйл болон бусад хувийн мэдээллийг устгах уу? Энэ үйлдлийг буцаах боломжгүй.', erasePiiDone: 'Хувийн мэдээлэл устгагдлаа',
        notes: 'Тэмдэглэл',
        registrationNo: 'Регистрийн дугаар',
        registrationNoInvalid: 'Регистрийн дугаар нь 2 кирилл үсэг, араас нь 8 цифр байна, жишээ нь УБ12345678.',
        allTeams: 'Бүх баг', showInactive: 'Идэвхгүйг харуулах', downloadExcel: 'Excel татах',
        downloaded: '{{count}} ажилтан Excel-ээр татагдлаа.', downloadFailed: 'Excel файл үүсгэж чадсангүй.', directorySheet: 'Лавлах',
        newEmployee: 'Шинэ ажилтан', empty: 'Ажилтан алга', saved: 'Хадгаллаа', savedTeams: 'Багийн мэдээлэл хадгалагдлаа', savedSalary: 'Цалин хадгалагдлаа', emailNeededForSignIn: 'Энэ хүн энэ имэйлээр нэвтэрдэг тул хоосон үлдээх боломжгүй. Оронд нь өөр хаяг оруулна уу.',
        contractLegend: 'Гэрээний төлөв', legendExpired: 'Дууссан', legendSoon: '1 сарын дотор', legendWatch: '3 сарын дотор',
        tabGeneral: 'Ерөнхий', tabTeams: 'Баг', tabSalary: 'Цалин',
        saveGeneral: 'Ерөнхий хадгалах', saveTeams: 'Баг хадгалах', saveSalary: 'Цалин хадгалах',
        entity: 'ТРГ хуулийн этгээд', nobodyAssigned: 'Хуваарилагдаагүй',
        viewReporting: 'Удирдлагын шугам', viewTeams: 'Багууд', viewProducts: 'Бүтээгдэхүүн, үйлчилгээ',
        chainAbove: 'Дээд удирдлага', noSupervisor: 'Шууд удирдлагагүй', expand: 'Дэлгэх', collapse: 'Хураах',
        directReports: 'Харьяа ажилтнууд', fullRecordRestricted: 'Бүрэн бичлэгийг үзэхэд HR-ийн эрх шаардлагатай',
        openRecord: 'Нээх', showLess: 'Хураах', clearFilter: 'Шүүлтүүрийг арилгах',
        peopleShown: '{{count}} ажилтан',
        rateEditDate: 'Эхлэх огноог засах', rateNewDate: 'Шинэ эхлэх огноо', rateSaveDate: 'Огноо хадгалах', rateCancel: 'Болих',
        rateDelete: 'Энэ мөрийг устгах', rateDeleteConfirm: '{{date}}-нээс эхлэх цалингийн мөрийг устгах уу?',
        rateMoved: 'Эхлэх огноо өөрчлөгдлөө', rateDeleted: 'Цалингийн мөр устгагдлаа',
        rateDateTaken: 'Энэ огноогоор эхлэх өөр мөр аль хэдийн байна.',
        rateLocked: 'Олгогдсон цалин {{day}}-ний өдрийг энэ цалингаар аль хэдийн тооцсон. Ашиглагдсан цалинг зөвхөн {{floor}}-нээс хойш өөрчилж болно.',
        nothingToSave: 'Хадгалах өөрчлөлт алга',
        rateLockLoading: 'Хаагдсан сарууд ачаалж байна',
        rateDateUnchanged: 'Одоогийнхоос өөр огноо сонгоно уу',
        rateLockedRow: 'Олгогдсон цалинд ашиглагдсан тул устгах боломжгүй. Оронд нь {{floor}}-нээс эхлэх шинэ цалин нэмнэ үү.',
        rateSocLocked: 'Энэ өөрчлөлт {{month}}-ын НДШ-ийн кодыг {{from}}-оос {{to}} болгоно. Олгогдсон цалин уг кодыг аль хэдийн хадгалсан. Ашиглагдсан цалинг зөвхөн {{floor}}-нээс хойш өөрчилж болно.',
        rateSocNone: 'байхгүй',
        periodsTitle: 'Цалингийн үеүүд',
        periodsHint: 'Энэ ажилтны цалингийн тооцоонууд. Үе дээр дарж олгосон үеийн задаргааг харна уу.',
        periodsNone: 'Энэ ажилтанд цалингийн тооцоо хараахан алга.',
        periodsLoadFailed: 'Цалингийн үеүүдийг ачаалж чадсангүй',
        periodAdvance: 'Урьдчилгаа',
        periodFinal: 'Сүүл цалин',
        periodDraft: 'Ноорог',
        periodDraftNote: 'Хараахан олгоогүй: ноорогийг Цалин хэсэгт шууд дахин тооцдог тул энд хадгалсан дүн байхгүй, тоо харуулахгүй.',
        periodTotalsOnly: 'Задаргааг хадгалдаг болохоос өмнө олгосон: зөвхөн нийт дүнгүүд хадгалагдсан.',
        periodMeta: 'Хаалт {{cut}} · {{days}} · {{hours}} ц · төлбөр {{status}}',
        periodSpan: 'Өдрүүд',
        periodHours: 'Цаг',
        periodTasks: 'Даалгавар',
        periodCarried: 'шилжиж орсон',
        periodDayHours: 'Өдрөөр цаг: {{days}} өдөр, оруулсан {{entered}} ц, зөвшөөрсөн {{allowed}} ц',
        periodDayHoursNotRecorded: 'Энэ тооцоог олгох үед өдрөөрх цаг бүртгэгдээгүй.',
        periodNotRecorded: 'Бүртгэгдээгүй',
        periodDaysCount: '{{count}} өдөр',
        periodGross: 'Нийт',
        periodAllowance: 'Нэмэгдэл',
        periodBonus: 'Урамшуулал',
        periodDeduction: 'Суутгал',
        periodSocial: 'НДШ',
        periodTax: 'ХХОАТ',
        periodNet: 'Цэвэр',
        periodAdvancePaid: 'Олгосон урьдчилгаа',
        periodAdvanceAdjustment: 'Урьдчилгааны залруулга',
        periodNetAdjustment: 'Цэвэр дүнгийн залруулга',
        periodPayable: 'Олгох дүн',
        rateFrozenMonths: 'Хаагдсан эсвэл олгогдсон сар хөндөгдлөө: {{months}}. Эдгээр сарын цалинг дахин тооцохгүй.',
        rateHistory: 'Цалингийн түүх', noRates: 'Цалингийн бүртгэл алга', currentRate: 'Одоогийн',
        estimatedMonthly: 'Тооцоолсон сарын дүн: {{amount}}', estimatedMonthlyNote: '8ц × 260 өдрөөр',
        dailyRate: 'Өдрийн цалин', hourlyRate: 'Цагийн цалин', hourlyRateRequired: 'Цагийн цалинг оруулна уу.', effectiveSince: 'Мөрдөх огноо', rateType: 'Цалингийн хэлбэр', payBasis: { hourly: 'Цагаар', daily: 'Өдрөөр', fixed: 'Тогтмол', dailyHourly: 'Өдрөөр + цагаар', choose: 'Сонгох…' }, payBasisRequired: 'Хадгалахын өмнө цалингийн хэлбэрийг (цагаар, өдрөөр, тогтмол) сонгоно уу.', rateGapNote: { effective_since: 'Мөрдөх огноо хоосон байна.', type_of: 'Цалингийн хэлбэр хоосон байна.', rate: 'Цалин хоосон эсвэл 0 байна. Зөв эсэхийг шалгана уу.', soc_ins_code: 'Нийгмийн даатгалын код хоосон байна.' }, rateGapName: { effective_since: 'мөрдөх огноо', type_of: 'цалингийн хэлбэр', rate: 'цалин', soc_ins_code: 'нийгмийн даатгал' }, rateIncomplete: 'Цалингийн мэдээлэл дутуу: {{fields}}', noPayRate: 'Цалин бүртгэлгүй', unratedLogged: '{{before}}-ээс өмнө бүртгэсэн {{count}} өдөр цалинжихгүй: {{dates}}', columns: 'Багана', columnsReset: 'Үндсэн баганууд', columnsSaveStaffDefault: 'Ажилтнуудад үндсэн болгох', columnsSaveStaffDefaultHint: 'ХН-ийн бүртгэл харах эрхгүй, өөрөө багана сонгоогүй хүмүүс эдгээрийг харна. Бүртгэл болон цалингийн баганыг оруулахгүй.', columnsSaveHrDefault: 'ХН-д үндсэн болгох', columnsSaveHrDefaultHint: 'ХН-ийн бүртгэл харах эрхтэй, өөрөө багана сонгоогүй хүмүүс эдгээрийг харна. Цалингийн баганыг зөвхөн эрхтэй хүн харна.', columnsDefaultSaved: 'Үндсэн баганыг хадгаллаа', columnGroup: { directory: 'Лавлах', record: 'Хувийн хэрэг', salary: 'Одоогийн цалин' }, rateIncompleteColumn: 'Цалингийн мэдээлэл дутуу', bankAccountColumn: 'Банкны данс', rate: 'Цалин', taskRate: 'Даалгаврын үнэ',
        additional: 'Нэмэгдэл',
        socIns: 'НД код', transitAdd: 'Унааны нэмэгдэл',
        transitNoneDailyHourly: 'Унааны нэмэгдэл: өдөр+цагийн хөлсөнд байхгүй, гэрээтийн бүртгэл зөвхөн өдөр, цагийг цалинжуулна.',
        taskRuleSet: 'Даалгаврын үнийн дүрэм',
        taskRuleSetNone: '— байхгүй (тогтмол үнэ)',
        taskRateNotUsed: 'Дүрмийн багц сонгосон тул тогтмол үнэ ашиглагдахгүй.',
        socInsTaxExempt: 'татвараас чөлөөлөгдсөн',
        workConditionNormal: 'Хэвийн',
        workConditionSpecial: 'Тусгай',
        personalEmailInvalid: 'Хувийн и-мэйл хаяг буруу байна, жишээ нь bat@gmail.com.',
        phoneInvalid: 'Утасны дугаар зөвхөн тоо агуулна, эхэнд нь + байж болно.',
        rateVersionNote: 'Цалин, нэмэгдэл, НД код өөрчлөгдвөл шинэ хувилбар үүснэ. Бусад талбар одоогийн бичлэгийг засна.',
        // Under the account field; see lib/accountStatus.ts.
        
        
        // The salary bank accounts -- up to three, one of them
        // primary. `hr.account` above is the LEGACY single field on the pay
        // rate and is deliberately left where it is; these keys belong to the
        // new per-person table.
        bank: {
          title: 'Банкны данс',
          add: 'Данс нэмэх',
          primaryNote: 'Цалинг зөвхөн үндсэн данс руу шилжүүлнэ. Бусад нь зөвхөн мэдээллийн зориулалттай.',
          empty: 'Бүртгэлтэй банкны данс алга',
          loadFailed: 'Банкны дансуудыг ачаалж чадсангүй',
          noPrimaryWarning: 'Аль нь ч цалингийн данс гэж тэмдэглэгдээгүй тул энэ ажилтан шилжүүлгийн файлд орохгүй. Нэгийг сонгоно уу.',
          primary: 'Цалингийн данс',
          atCap: 'Нэг ажилтан хамгийн ихдээ {{max}} данстай байна. Шинийг нэмэхийн тулд нэгийг устгана уу.',
          saved: 'Банкны данс хадгалагдлаа',
          removed: 'Банкны данс устгагдлаа',
          bankName: 'Банк',
          choose: 'Банк сонгох',
          accountNumber: 'Дансны дугаар (IBAN)',
          accountName: 'Данс эзэмшигчийн нэр',
          accountNameHint: 'Банкинд бүртгэлтэй нэр — энд байгаагаас өөр бол.',
          bankRequired: 'Банкаа сонгоно уу',
          numberRequired: 'Дансны дугаарыг оруулна уу',
          shapeHint: 'Монголын дансны дугаар 20 тэмдэгт: MN, дараа нь 18 орон.',
          codeMismatch: 'Энэ дугаар сонгосон банкнаас өөр банкных байна. Хоёуланг нь шалгана уу.',
          makePrimary: 'Үүнийг цалингийн данс болгох',
          forcedPrimary: 'Энэ бол цалингийн данс — бүртгэлтэй цорын ганц данс.',
          selfNote: 'Бусад дансаа нэмж, засаж, устгаж болно. Цалингийн үндсэн дансыг зөвхөн хүний нөөц сонгож, өөрчилнө.',
          selfNoPrimary: 'Хүний нөөц таны цалингийн үндсэн дансыг хараахан сонгоогүй байна. Цалин шилжүүлэхийн тулд тэдэнд хандана уу.',
        },
        roleHistory: 'Дүрийн түүх', roleHistoryEmpty: 'Түүх алга', roleHistoryBaseline: 'Эхлэл',
        roleHistoryUnassigned: 'Хуваарилагдаагүй', productRetired: '(идэвхгүй)', roleHistorySince: '{{date}}-с',
        recordTrail: 'Бүртгэлийн мөр',
        recordCreatedBy: 'Үүсгэсэн',
        recordUpdatedBy: 'Сүүлд өөрчилсөн',
        recordNoActor: 'Импортоор орсон — хэрэглэгч бүртгэгдээгүй',
        recordUnknownActor: 'Тодорхойгүй хэрэглэгч',
        externalNew: 'Шинэ гадны ажилтан',
        externalNameRequired: 'Нэр оруулна уу',
        externalCompanyRequired: 'Компанийг оруулна уу',
        externalFillFirst: 'Эхлээд од (*) бүхий талбаруудыг бөглөнө үү',
        externalsLoadFailed: 'Гадны ажилтнуудыг ачаалж чадсангүй',
        externalEditTitle: 'Гадны ажилтан засах',
        externalViewTitle: 'Гадны ажилтан',
        externalEmailField: 'И-мэйл (заавал биш)',
        externalEmailRequiredField: 'И-мэйл',
        emailLockAdminOnly: 'Зөвхөн админ эсвэл Хэрэглэгчдийн хуудсыг удирддаг хүн и-мэйл өөрчилж чадна',
        emailLockOwn: 'Та өөрийн и-мэйлийг өөрчлөх боломжгүй',
        emailLockAdminTarget: 'Гишүүнээс дээш эрхтэй хүний и-мэйлийг зөвхөн админ өөрчилж чадна',
        emailClearsMicrosoftLink: 'Хадгалахад Microsoft салгана',
        externalPhoneField: 'Утас (заавал биш)',
        externalBankAfterSave: 'Банкны данс нэмэхийн тулд эхлээд энэ ажилтныг хадгална уу. Одоогоор данс хадгалагдаагүй байна.',
      },
      admin: {
        newUser: 'Шинэ хэрэглэгч',
        levelName: { 'contractor-self-log': 'Гэрээт ажилтан (өөрөө цаг бүртгэнэ)' },
        groupLabel: 'Бүлэг',
        accountLabel: 'Бүртгэл',
        unsaved: 'хадгалаагүй',
        editUser: '{{name}}-г засах',
        draftBadge: 'Шинэ',
        addDraft: 'Нэмэх',
        removeDraft: 'Хасах',
        usersLoadFailed: 'Хэрэглэгчдийг ачаалж чадсангүй.',
        noFinanceSigner: 'Санхүүгийн шатыг баталгаажуулах хүн алга тул ээлжийн амралт хүлээгдэж буй төлөвт үлдэнэ: нэг хүнд CFO түвшин өгнө үү. Ээлжийн амралт авах хүний ажлын төрөл мөн Full Time байх ёстой.',
        accessLevels: 'Хандалтын түвшин',
        accessLevelsHint: 'Эрх нь хүнд биш, түвшинд харьяалагдана. Өөр багц эрх хэрэгтэй бол шинэ түвшин үүсгэнэ.',
        newLevel: 'Шинэ түвшин',
        levelAbilities: 'Эрх',
        levelLabel: 'Нэр',
        levelSlug: 'Богино нэр',
        levelInUse: '{{n}} хэрэглэгч энэ түвшинд байна',
        nUsers: '{{n}} хэрэглэгч',
        saveWithCount: '{{n}} өөрчлөлт хадгалах',
        discardChanges: 'Өөрчлөлтийг цуцлах',
        confirmTitle: 'Өөрчлөлтийг баталгаажуулах',
        emailMissing: 'И-мэйл хаягаа оруулна уу.',
        emailInvalid: 'Энэ и-мэйл хаяг биш байна — үсгийн алдаа шалгана уу.',
        nothingToSave: 'Хадгалах өөрчлөлт алга.',
        applyFailed: 'Бүх өөрчлөлт хадгалагдсангүй; жагсаалт одоо хадгалагдсаныг харуулж байна.',
        viewAsFailed: '{{name}}-ээр харж чадсангүй.',
        inviteFailed: '{{email}} хаягийг урьж чадсангүй.',
        inviteResendFailed: '{{email}} руу урилгыг дахин илгээж чадсангүй.',
        levelSaveFailed: '«{{name}}» түвшинг хадгалж чадсангүй.',
        levelBasicRequired: '«Үндсэн»-ийг мөн сонгоно уу: түүнгүйгээр энэ түвшний бусад эрх юу ч нээхгүй.',
        levelDeleteFailed: '«{{name}}» түвшинг устгаж чадсангүй.',
        levelLabelMissing: 'Түвшний нэрийг оруулна уу.',
        levelSlugMissing: 'Богино нэрийг оруулна уу.',
        levelSlugInvalid: 'Жижиг латин үсгээр эхэлж, жижиг үсэг, тоо, - эсвэл _ ашиглана.',
        levelUnchanged: 'Энэ түвшинд өөрчлөлт алга.',
        confirmApply: '{{n}} өөрчлөлтийг хэрэглэх',
        changeName: 'нэр: {{from}} → {{to}}',
        changeLevel: 'хандалт: {{from}} → {{to}}',
        changeActivated: 'идэвхжүүлэх',
        changeDeactivated: 'идэвхгүй болгох',
        changeCreated: 'шинээр үүсгэх ({{level}})',
        toggleActive: '{{name}}-н нэвтрэх эрхийг асаах/унтраах',
        changeDeactivateWithConsequence:
          'нэвтрэх эрхийг унтраана — HR дахь ажлын төлөв өөрчлөгдөхгүй, түүнийг HR тохируулна',
        changeReactivateWithConsequence: 'нэвтрэх эрхийг асаана — HR дахь ажлын төлөв өөрчлөгдөхгүй',
        inviteExternal: 'Гадны хэрэглэгч урих',
        inviteTitle: 'Гадны хэрэглэгч урих',
        inviteHint: 'Майкрософт урилга илгээж, холбоосыг нь өөрөө хүргэнэ. Уригдсан хүн хандалтын түвшин олгогдтол юунд ч хандахгүй.',
        inviteSend: 'Урилга илгээх',
        inviteSent: 'Урилга илгээлээ',
        inviteResent: 'Урилгыг дахин илгээлээ',
        inviteResend: 'Дахин илгээх',
        inviteNever: '—',
        invitePending: 'Илгээсэн, хараахан нэвтрээгүй',
        inviteCopyLink: 'Холбоос хуулах',
        inviteLinkCopied: 'Холбоосыг хуулав',
        noAccessTitle: 'CenTrig-д хандах эрхгүй',
        noAccessBody:
          'Та нэвтэрсэн боловч энэ бүртгэлд хандах эрх олгогдоогүй байна. Хандах эрхтэй байх ёстой бол админтай холбогдоно уу.',
        noAccessSignedInAs: '{{email}}-ээр нэвтэрсэн',
        filterByLevel: 'Түвшингээр шүүх',
        allLevels: 'Бүх түвшин',
        filterByType: 'Ажлын хэлбэрээр шүүх',
        allTypes: 'Бүх төрөл',
        notSet: 'Тодорхойгүй',
        rosterColumn: 'Ээлжийн хуваарь',
        rosterManagerNote: 'Ээлжийн менежерийг хүн бүрээр нь ээлжийн Хүмүүс хуудсанд тэмдэглэнэ.',
        rosterManagerNoteLink: 'Хүмүүс хуудас руу',
        inventoryColumn: 'Хөрөнгө',
        usernameColumn: 'Нэвтрэх нэр',
        rosterManager: 'Ээлжийн менежер',
        rosterStaff: 'Ээлжийн ажилтан',
        rosterPerson: 'Ээлжийн хуваарьт бүртгэлтэй',
        showingCount: '{{total}}-аас {{n}}-г харуулж байна',
        clearFilters: 'Бүгдийг харуулах',
        noUsersMatchFilters: 'Энэ шүүлтүүрт тохирох ажилтан алга',
        noUsersMatchSearch: '“{{q}}” хайлтад тохирох хэрэглэгч алга',
        sortBy: '{{column}}-аар эрэмбэлэх',
        // The three ready filters, the fourth catch-all, and what
        // this page says about a person who has no login at all.
        filterByAccount: 'Эрхээр шүүх',
        accountWithAccount: 'Эрхтэй хүмүүс',
        accountEveryone: 'Бүх хүн (эрхгүй ч гэсэн)',
        filterByGroup: 'Бүлгээр шүүх',
        allGroups: 'Бүх хүн',
        groupFullTime: 'Манай бүтэн цагийн хүмүүс',
        groupStaffOther: 'Манай бусад хүмүүс',
        groupExternal: 'Гадны компанийн бүртгэл',
        groupUnaffiliated: 'Хүний нөөцийн бүртгэлгүй',
        noAccount: 'Бүртгэлгүй',
        grantAccountHint: 'Хандах түвшин сонговол энэ хүнд бүртгэл үүснэ',
        changeGrantAccount: '{{level}} түвшинтэй шинэ бүртгэл үүсгэх',
        noExternalsHere:
          'Гадны компанийн хүн одоогоор бүртгэлд алга. Тэднийг Ээлжийн хуваарь хэсгийн Хүмүүс дэд хуудсаас нэмнэ. Тэдэнд энд нэвтрэх бүртгэл үүсгэдэггүй: олгосон хандалт нь түр зуурынх бөгөөд энэ хуудсанд хугацаа нь хянагддаггүй.',
        // The ability catalogue is defined in the backend (`core/permissions.py`);
        // its labels are translated here and keyed by the ability KEY, which is what the
        // database stores -- so nothing below renames, merges or removes a grant.
        // `AdminUsers.tsx` falls back to the API label if a key here is missing.
        abilityGroup: {
          hr: 'Ажилтнууд',
          pay: 'Цалин',
          approvals: 'Батлах',
          time: 'Цаг ба чөлөө',
          roster: 'Ээлжийн хуваарь',
          admin: 'Админ',
          other: 'Ангилагдаагүй',
        },
        abilityName: {
          basic: 'Үндсэн',
          self_log: 'Өөрийн бүртгэл',
          staff: 'Ажилтан',
          hr_view: 'Хүний нөөцийн бүртгэл харах',
          hr_extra: 'Хувийн бүртгэлийн нэмэлт',
          hr_edit: 'Хүний нөөц засах',
          staff_lifecycle_notify: 'Ажилд орох, гарах мэдэгдэл',
          salary_view: 'Цалин харах',
          payroll: 'Цалин бодолт',
          activity_fund_edit: 'Үйл ажиллагааны сан',
          sales_invoice: 'Борлуулалтын нэхэмжлэх',
          sales_sign_as_other: 'Өөр хүний гарын үсгээр хэвлэх',
          requests_approve: 'Хүсэлт батлах',
          signoff_ceo: 'Гүйцэтгэх захирлаар батлах',
          signoff_cfo: 'Санхүүгийн захирлаар батлах',
          time_admin: 'Цагийн админ',
          calendar_edit: 'Хуанли засах',
          leave_admin: 'Чөлөөний админ',
          roster_plan: 'Ээлжийн менежер',
          admin_elevate: 'Түр админ',
          admin: 'Админ',
          roster_self: 'Өөрийн ээлжийн хуваарь',
          public_view: 'Нийтийн харагдац',
        },
        abilityHelp: {
          basic: 'Хянах самбар, бүтэц, компанийн хуанлийн үйл явдал; бүртгэлтэй бол Миний самбар',
          self_log: 'Өөрийн цагийг бүртгэх, ширээ захиалах, чөлөө хүсэх',
          staff: 'Борлуулалтын үнийн санал, хүсэлт, томилолт, харилцагч, үнийн жагсаалт, хамт олны профайл, үйл ажиллагааны сан, хуанли дахь чөлөөтэй хүмүүс',
          hr_view: 'Ажилтны жагсаалт, түүх, хүний нөөцийн самбарыг унших (зөвхөн харах)',
          hr_extra: 'Регистрийн дугаар, өмнөх сарууд, гэрээний дуусах огноо, асрамжийн хүүхэд болон тэмдэглэлийг харах',
          hr_edit: 'Ажилтны бүртгэл, цалингийн хэмжээ, банкны данс, бүтцийн үүргийг засах',
          staff_lifecycle_notify: 'Хэн нэгэн ажилд орох эсвэл гарахад нийгмийн даатгалын төлөө и-мэйл авах',
          salary_view: 'Цалингийн хэмжээ, цалингийн бодолтыг унших (зөвхөн харах)',
          payroll: 'Цалин бодох, хаах, гаргах; компанийн хувь хэмжээ, ажлын дүрэм тогтоох; ажлаас гарсан хүний тооцоо хаах; компанийн банкны данс засах; томилолтын төлбөр хийх; бүх хүсэлт, борлуулалтын баримтыг харах',
          activity_fund_edit: 'Үйл ажиллагааны сангийн орлого, зарлагыг бүртгэх',
          sales_invoice: 'Борлуулалтын нэхэмжлэх үүсгэж гаргах, хэний ч борлуулалтын баримт дээр үйлдэл хийх',
          sales_sign_as_other: 'Борлуулалтын баримтын PDF дээр өөрийнхөө биш, нэхэмжлэх гаргах эрхтэй өөр хүний гарын үсгийг хэвлэх',
          requests_approve: 'Нөхөн олговор, худалдан авалт, томилолтын хүсэлтийг батлах',
          signoff_ceo: 'Гүйцэтгэх захирлын шатанд гарын үсэг зурах',
          signoff_cfo: 'Санхүүгийн захирлын шат, түүний дотор чөлөөний санхүүгийн шатанд гарын үсэг зурах',
          time_admin: 'Хэний ч цагийн бүртгэл (цалингийн хугацаанд багтах өмнөхийг оруулаад), үйл ажиллагааг засах',
          calendar_edit: 'Баярын өдөр нэмэх, хасах, өмнөх оны хуанлийг хуулах, оныг баталгаажуулах; цалингийн тасалбар огноо дагаж өөрчлөгдөнө',
          leave_admin: 'Чөлөө, үлдэгдлийг удирдах; чөлөөний хоригийг нэг удаа давах зөвшөөрөл олгох',
          roster_plan: 'Ээлжийн хуваарийн бүх табыг төлөвлөж засах (зөвхөн ээлжийн ажилтан)',
          admin_elevate: 'Шалтгаанаа бүртгүүлээд өөртөө 8 хүртэл цагийн админ эрх олгох',
          admin: 'Бүртгэл, эрхийн түвшин, автомат сануулгыг удирдах',
          roster_self: 'Өөрийн ээлжийн хуваарийг харах',
          public_view: 'Хянах самбар, компанийн хуанли, бүтэц; хувийн мэдээлэлгүй',
        },
        levelSpecial: 'Тусгай эрх',
        impliedBy: '«{{name}}»-д багтсан',
        notHeld: 'Өөрт байхгүй эрхийг зөвхөн админ олгоно',
        fixedLevel: 'Тогтмол тохиргоо: энэ түвшнийг засах боломжгүй.',
        editInHr: 'HR-д засах',
        readOnlyNotice: 'Нэр HR-ээс ирнэ — өөрчлөхийн тулд HR бичлэгийг нээнэ үү.',
        viewAs: 'Харах',
        viewingAs: '{{name}}-г харж байна',
        viewingAsBanner: 'Та {{name}} ({{email}})-г харж байна — бичих боломжгүй',
        exitViewAs: 'Харах горимоос гарах',
        identityAction: 'Microsoft хэрэглэгч',
        identityTitle: 'Microsoft хэрэглэгч',
        identityLoadFailed: 'Холбогдсон хэрэглэгчийг унших боломжгүй тул өөрчлөх боломжгүй.',
        identityLinked: 'Microsoft хэрэглэгчтэй холбогдсон',
        identityUnlinked: 'Microsoft хэрэглэгчтэй холбогдоогүй',
        identityOid: 'Объектын ID',
        identityEmail: 'Хаяг',
        identityReplaceLabel: 'Шинэ объектын ID',
        identityReplaceHint: 'Эхлээд хоёр ID-г Entra дээр шалгана уу. Нэр солигдсон бүртгэл нь дахин холболт биш.',
        identityReplace: 'Солих…',
        identityClear: 'Холболтыг арилгах…',
        identityClearHint: 'Арилгасны дараа энэ хаягаар эхний нэвтрэлт шинэ хэрэглэгчийг холбоно.',
        identityInvalid: 'Энэ нь хүчинтэй объектын ID (UUID) биш.',
        identitySame: 'Энэ хэрэглэгч аль хэдийн холбогдсон байна.',
        identityReplaceMissing: 'Эхлээд шинэ объектын ID-г буулгана уу.',
        identityConfirmReplace: 'Холбогдсон хэрэглэгчийг {{oid}}-аар солих уу? Хуучин хэрэглэгчээр нэвтрэх боломжгүй болно.',
        identityConfirmClear: 'Холболтыг арилгах уу? Энэ хаягаар дараагийн нэвтрэлтээр нэвтэрсэн хэрэглэгч холбогдоно.',
        identityConfirm: 'Баталгаажуулах',
        identityBack: 'Буцах',
        identityClose: 'Хаах',
        identityDoneReplaced: 'Хэрэглэгч солигдлоо',
        identityDoneCleared: 'Холболт арилгагдлаа',
        identityRefNotFound: 'Энэ хүнд бүртгэл байхгүй болсон байна.',
        identityRefAdminOnly: 'Админыг зөвхөн админ дахин холбож чадна.',
        identityRefSelf: 'Өөрийн хэрэглэгчийг дахин холбох боломжгүй.',
        identityRefNotLinked: 'Энэ бүртгэл холбогдоогүй тул дахин холбох зүйлгүй. Одоогийн төлөвийг харахын тулд дахин ачаална уу.',
        identityRefStale: 'Нээснээс хойш холбогдсон хэрэглэгч өөрчлөгдсөн. Дахин ачаалж шалгана уу.',
        identityRefSameOid: 'Энэ хэрэглэгч аль хэдийн холбогдсон байна.',
        identityRefTaken: 'Энэ хэрэглэгч аль хэдийн {{holder}}-тэй холбогдсон байна.',
        identityRefInvalid: 'Хүсэлтийг хүчингүй гэж татгалзлаа.',
      },
  },
  en: {
      clBonus: {
        title: 'Casual leave bonus days',
        intro: 'Everyone is paid {{days}} days of casual leave (CL) a year. An employee of the year can be granted extra paid days for one calendar year. Payroll uses it; leave balances are not changed.',
        loadFailed: 'Could not load the bonus days',
        paidThisYear: 'Paid CL in {{year}}: {{days}} days',
        none: 'No bonus days granted.',
        year: 'Year', extraDays: 'Extra days', note: 'Note', grantedBy: 'Granted by',
        grant: 'Grant', replace: 'Replace', revoke: 'Revoke',
        replaceConfirm: 'Replace the bonus for {{year}}?',
        revokeConfirm: 'Revoke the bonus for {{year}}? Paid CL for that year goes back to 3 days.',
        saved: 'Bonus days saved', revoked: 'Bonus days revoked',
        saveFailed: 'Could not save',
        badYear: 'Enter a year from 2000 to 2100',
        badDays: 'Enter more than 0 and at most 365 days',
        halfDays: 'Use whole or half days',
      },
      hr: {
        orgTabDirectory: 'Directory', orgTabChart: 'Org chart', orgTabsLabel: 'Organization sections', orgDirectoryEmpty: 'No people found', directoryLoadFailed: 'Could not load the staff list. Try again shortly.', statusInactive: 'Inactive', orgStatsHeading: 'Company figures', genderNotRecorded: 'Not recorded', orgStatsLoadFailed: 'Could not load the company figures.', searchStaff: 'Search staff',
        orgFilterShowing: 'Showing: {{name}}', orgFilterCount: '{{count}} of {{total}} shown', orgFilterClear: 'Clear filter', orgFilterNone: 'Nobody in this selection', orgFilterHint: 'Click a team or product to filter the chart',
        name: 'Name', staffId: 'Staff ID', staffIdField: 'Staff ID', staffCode: 'Staff code',
        supervisor: 'Supervisor', peer: 'Peer', team: 'Team', workType: 'Work type',
        workCondition: 'Work condition', position: 'Position', positionMn: 'Position (MN)', positionZh: 'Position (ZH)',
        contractEnd: 'Contract end', phone: 'Phone', email: 'Work email', personalEmail: 'Personal email',
        displayName: 'Display name', firstName: 'First name', lastName: 'Last name', firstNameMn: 'First name (Cyrillic)', lastNameMn: 'Last name (Cyrillic)',
        office: 'Office', status: 'Status', dob: 'Date of birth', gender: 'Gender', genderBlank: '—', genderMale: 'Male', genderFemale: 'Female', country: 'Country', degree: 'Degree', profession: 'Profession',
        emergencyName: 'Emergency contact', emergencyPhone: 'Emergency phone',
        specialNeeds: 'Special needs', dependentChildren: 'Dependent children', workedSince: 'Worked since', fullTimeStart: 'Full-time start', monthsBefore: 'Months insured before joining',
        workedSinceHelp: 'The first day of work. Hiring or re-hiring opens the employment record from this day, and the six months before annual leave is first granted count from it. Payroll shows it as the employment start, the new-employee social insurance request to Legal carries it, and work anniversaries count from it. Editing it moves the start of the current employment record with it.',
        fullTimeStartHelp: 'The day Full Time began; when blank, the start date is used. Annual leave service and the yearly casual and sick leave reset count from it, and payroll counts public holidays for a full-timer only from this date. Editing it moves the Full Time start of the current employment record with it.',
        monthsBeforeHelp: 'Months of social insurance before joining. The annual leave band adds them to the full-time months here up to April 2026 and each month from May 2026 in which issued payroll deducted social insurance; a finished month whose payroll is not issued yet counts until it is. No other calculation reads this field.',
        resignationDate: 'Resignation date',
        resignationDateRequired: 'Enter the resignation date to set this person Inactive',
        fieldRequired: 'Required',
        workedSinceRequired: 'Enter the start date (worked since) to keep this person Active',
        finalPay: {
          title: 'Final pay',
          hint: "Choose how this person's final pay and payout were settled, and add a comment.",
          paid: 'Paid',
          next_payroll: 'Will be paid in the next final payroll',
          owed: 'Not paid: save what is owed',
          other: 'Other: say in the comment how it was settled',
          comment: 'Comment',
          required: 'Choose the final-pay outcome and add a comment to set this person Inactive',
        },
        reactivateUndoConfirm: 'This restores {{name}} as before: their leave balances and employment period stay as they are and the resignation date is cleared. Leave cancelled by a resignation date in this employment period is put back with its paid or unpaid record. If a leave payout or resignation leave settlement is on file, the save is refused until it is voided. Continue?',
        reactivateRehireConfirm: 'This re-hires {{name}} from {{date}}: a new employment period starts and their AL, CL and PSL start from zero. Continue?',
        reactivateRestored: 'Leave requests restored: {{count}}',
        undoRefusedPayout: 'The cancelled leave cannot be put back yet: a {{status}} leave payout close-out (resignation date {{date}}) is on file. Void it first. If the money has already been paid, bring them back as a re-hire with a new start date instead.',
        undoRefusedSettlement: 'The cancelled leave cannot be put back yet: a {{status}} resignation leave settlement ({{days}} days requested) is on file. Reject it first. If the money has already been paid, bring them back as a re-hire with a new start date instead.',
        undoRefusedPaidOff: 'The cancelled leave cannot be put back yet: the leave was marked paid off after the deactivation ({{note}}). Correct the balance by hand first. If the money has already been paid, bring them back as a re-hire with a new start date instead.',
        reactivateNotRestored: 'These cancelled requests overlap leave filed since, so they stay cancelled. Check them and re-file by hand if needed: {{list}}',
        deactivateWarnTitle: 'Saving this changes more than {{name}}\'s record. Read this before you continue.',
        deactivateWarnSignIn: '• Sign-in: if they have one, it is switched off. For 90 days after the resignation date they can open only their own payslips; after that, nothing.',
        deactivateWarnRoster: '• Roster: they show as having left, and they can no longer be added to it.',
        deactivateWarnLeave: '• Leave: every leave request starting after {{date}} is cancelled, pending ones included, except annual leave that payroll has already paid. Approved days go back onto the balance.',
        deactivateWarnUndo: 'To undo, set them Active again with the same start date: the sign-in and the roster come back, and so does leave cancelled in this employment period, with its paid or unpaid record and any leave-rule override it used. Leave changed since, or overlapping leave filed since, stays cancelled. While a leave payout or resignation leave settlement is on file, the undo is refused until it is voided. With a new start date it is a re-hire, and AL, CL and PSL start from zero.',
        deactivateWarnDateOnly: 'Moving this date later, or clearing it, does not bring cancelled leave back: it has to be re-filed by hand.',
        formerEmployee: '(former employee)',
        sectionPersonal: 'Personal', sectionJob: 'Job', sectionContact: 'Contact', sectionOther: 'Other',
        attachLogin: 'Attach to a login', attachLoginNone: 'New record (no login to attach)', attachLoginHint: 'Logins that sign in with a username and password, have no Microsoft link and no employee record. Attaching asks for no e-mail.', sameNameWarning: 'Someone with this name is already on file: {{names}}. Check you are not adding a duplicate.',
        leaverTitle: 'Your employment has ended',
        leaverBody:
          'This account can now see only your own payslips. That access closes 90 days after your resignation date, so please download anything you need. Nothing has been deleted — HR and payroll keep these records permanently.',
        leaverSignedInAs: 'Signed in as {{email}}',
        personalDataHidden: 'Hidden: archived record',
        employeeLoadFailed: 'Could not load this employee record',
        extrasHidden: 'Hidden: needs Personal record extras',
        erasePii: 'Erase personal data', erasePiiConfirm: "Erase this person's phone, date of birth, personal email and other personal data? This cannot be undone.", erasePiiDone: 'Personal data erased',
        notes: 'Notes',
        registrationNo: 'Registration no.',
        registrationNoInvalid: 'The registration number must be 2 Cyrillic letters followed by 8 digits, e.g. УБ12345678.',
        allTeams: 'All teams', showInactive: 'Show inactive', downloadExcel: 'Download Excel',
        downloaded: 'Downloaded {{count}} staff as Excel.', downloadFailed: 'Could not make the Excel file.', directorySheet: 'Directory',
        newEmployee: 'New employee', empty: 'No staff found', saved: 'Saved', savedTeams: 'Teams saved', savedSalary: 'Salary saved', emailNeededForSignIn: 'This person signs in through this email, so it cannot be left blank. Enter another address instead.',
        contractLegend: 'Contract', legendExpired: 'Ended', legendSoon: 'Within a month', legendWatch: 'Within three months',
        tabGeneral: 'General', tabTeams: 'Teams', tabSalary: 'Salary',
        saveGeneral: 'Save general', saveTeams: 'Save teams', saveSalary: 'Save salary',
        entity: 'TRG entity', nobodyAssigned: 'Nobody assigned',
        viewReporting: 'Reporting line', viewTeams: 'Teams', viewProducts: 'Products & services',
        chainAbove: 'Reports up to', noSupervisor: 'No supervisor', expand: 'Expand', collapse: 'Collapse',
        directReports: 'Direct reports', fullRecordRestricted: 'Full record requires HR access',
        openRecord: 'Open', showLess: 'Show less', clearFilter: 'Clear filter',
        peopleShown: '{{count}} people',
        rateEditDate: 'Edit start date', rateNewDate: 'New start date', rateSaveDate: 'Save date', rateCancel: 'Cancel',
        rateDelete: 'Delete this row', rateDeleteConfirm: 'Delete the rate row starting {{date}}?',
        rateMoved: 'Start date changed', rateDeleted: 'Rate row deleted',
        rateDateTaken: 'Another row already starts on this date.',
        rateLocked: 'An issued payroll already priced {{day}} at this rate. A rate a payroll has used can change only from {{floor}} on.',
        nothingToSave: 'Nothing has changed yet',
        rateLockLoading: 'Checking which months are closed',
        rateDateUnchanged: 'Pick a date different from the current one',
        rateLockedRow: 'Used by an issued payroll, so it cannot be deleted. Add a new rate starting {{floor}} or later instead.',
        rateSocLocked: 'This change moves the soc code of {{month}} from {{from}} to {{to}}, which an issued payroll already stored. A rate a payroll has used can change only from {{floor}} on.',
        rateSocNone: 'none',
        periodsTitle: 'Pay periods',
        periodsHint: 'This person\'s payroll runs. Press a period to see what it was built from, as it was issued.',
        periodsNone: 'No payroll run for this person yet.',
        periodsLoadFailed: 'Could not load the pay periods',
        periodAdvance: 'Advance',
        periodFinal: 'Final',
        periodDraft: 'Draft',
        periodDraftNote: 'Not issued yet: Payroll recalculates a draft live, so nothing is frozen here and no figure is shown.',
        periodTotalsOnly: 'Issued before the working was frozen with each run: only the totals are kept.',
        periodMeta: 'Cut-off {{cut}} · {{days}} · {{hours}} h · payment {{status}}',
        periodSpan: 'Days',
        periodHours: 'Hours',
        periodTasks: 'Tasks',
        periodCarried: 'carried in',
        periodDayHours: 'Hours by day: {{days}} days, {{entered}} h entered, {{allowed}} h allowed',
        periodDayHoursNotRecorded: 'Hours by day were not recorded when this run was issued.',
        periodNotRecorded: 'Not recorded',
        periodDaysCount: '{{count}} days',
        periodGross: 'Gross',
        periodAllowance: 'Allowance',
        periodBonus: 'Bonus',
        periodDeduction: 'Deduction',
        periodSocial: 'Social insurance',
        periodTax: 'Income tax',
        periodNet: 'Net',
        periodAdvancePaid: 'Advance paid',
        periodAdvanceAdjustment: 'Advance adjustment',
        periodNetAdjustment: 'Net adjustment',
        periodPayable: 'Payable',
        rateFrozenMonths: 'This touched closed or issued months: {{months}}. Their pay is not re-calculated.',
        rateHistory: 'Rate history', noRates: 'No pay recorded', currentRate: 'Current',
        estimatedMonthly: 'Estimated monthly equivalent: {{amount}}', estimatedMonthlyNote: 'at 8 h × 260 days',
        dailyRate: 'Daily rate', hourlyRate: 'Hourly rate', hourlyRateRequired: 'Enter an hourly rate.', effectiveSince: 'Effective since', rateType: 'Pay basis', payBasis: { hourly: 'Hourly', daily: 'Daily', fixed: 'Fixed', dailyHourly: 'Daily + hourly', choose: 'Choose…' }, payBasisRequired: 'Choose a pay basis (hourly, daily or fixed) before saving.', rateGapNote: { effective_since: 'Effective since is empty.', type_of: 'Pay basis is empty.', rate: 'Rate is empty or 0. Check that is intended.', soc_ins_code: 'Social insurance is empty.' }, rateGapName: { effective_since: 'effective since', type_of: 'pay basis', rate: 'rate', soc_ins_code: 'social insurance' }, rateIncomplete: 'Incomplete pay rate: {{fields}}', noPayRate: 'No pay rate', unratedLogged: '{{count}} day(s) logged before {{before}} will not be paid: {{dates}}', columns: 'Columns', columnsReset: 'Default columns', columnsSaveStaffDefault: 'Save as default for staff', columnsSaveStaffDefaultHint: 'Shown to people without access to HR records who have not picked their own columns. Record and salary columns are left out.', columnsSaveHrDefault: 'Save as default for HR', columnsSaveHrDefaultHint: 'Shown to people with access to HR records who have not picked their own columns. Salary columns appear only to those allowed to see pay.', columnsDefaultSaved: 'Default columns saved', columnGroup: { directory: 'Directory', record: 'Personnel record', salary: 'Current pay rate' }, rateIncompleteColumn: 'Pay rate incomplete', bankAccountColumn: 'Bank account', rate: 'Rate', taskRate: 'Task rate',
        additional: 'Additional',
        socIns: 'Social insurance code', transitAdd: 'Transit allowance',
        transitNoneDailyHourly: 'Transit allowance: none on a daily+hourly rate; the contractor log pays days and hours only.',
        taskRuleSet: 'Task rule set',
        taskRuleSetNone: '— none (flat rate)',
        taskRateNotUsed: 'A rule set is chosen, so the flat task rate is not used.',
        socInsTaxExempt: 'tax-exempt',
        workConditionNormal: 'Normal',
        workConditionSpecial: 'Special',
        personalEmailInvalid: 'The personal email is not a valid address, e.g. bat@gmail.com.',
        phoneInvalid: 'A phone number holds only digits, with an optional + at the start.',
        rateVersionNote: 'Changing the rate, the additional amount or the social insurance code starts a new version. Any other change corrects the current one.',
        // Under the account field; see lib/accountStatus.ts.
        
        
        // The salary bank accounts -- up to three, one of them
        // primary. `hr.account` above is the LEGACY single field on the pay
        // rate and is deliberately left where it is; these keys belong to the
        // new per-person table.
        bank: {
          title: 'Bank accounts',
          add: 'Add bank account',
          primaryNote: 'Salary is paid into the primary account only. The others are recorded for information.',
          empty: 'No bank accounts on file',
          loadFailed: 'Could not load the bank accounts',
          noPrimaryWarning: 'None of these is marked as the salary account, so payroll will leave this person out of the transfer file. Choose one.',
          primary: 'Salary account',
          atCap: 'A person may have at most {{max}} accounts. Remove one to add another.',
          saved: 'Bank account saved',
          removed: 'Bank account removed',
          bankName: 'Bank',
          choose: 'Choose a bank',
          accountNumber: 'Account number (IBAN)',
          accountName: 'Account holder',
          accountNameHint: 'The name the bank has on file, if it differs from the name here.',
          bankRequired: 'Choose the bank',
          numberRequired: 'Enter the account number',
          shapeHint: 'A Mongolian account number is 20 characters: MN followed by 18 digits.',
          codeMismatch: 'This number belongs to a different bank from the one selected. Check both.',
          makePrimary: 'Make this the salary account',
          forcedPrimary: 'This is the salary account — the only one on file.',
          selfNote: 'You can add, change and remove your other accounts. Only HR chooses or changes your main salary account.',
          selfNoPrimary: 'HR has not chosen your main salary account yet. Ask HR so your salary can be transferred.',
        },
        roleHistory: 'Role history', roleHistoryEmpty: 'No history recorded', roleHistoryBaseline: 'Starting point',
        roleHistoryUnassigned: 'Not assigned', productRetired: '(retired)', roleHistorySince: 'since {{date}}',
        recordTrail: 'Record trail',
        recordCreatedBy: 'Created by',
        recordUpdatedBy: 'Last changed by',
        recordNoActor: 'Imported — no user recorded',
        recordUnknownActor: 'Unknown user',
        externalNew: 'New outside worker',
        externalNameRequired: 'Enter a name',
        externalCompanyRequired: 'Enter the company',
        externalFillFirst: 'Fill in the required (*) fields first',
        externalsLoadFailed: 'Could not load the outside workers',
        externalEditTitle: 'Edit outside worker',
        externalViewTitle: 'Outside worker',
        externalEmailField: 'Email (optional)',
        externalEmailRequiredField: 'Email',
        emailLockAdminOnly: 'Only an administrator, or someone who manages Users, can change an email',
        emailLockOwn: 'You cannot change your own email',
        emailLockAdminTarget: 'Only an administrator can change the email of a login above member',
        emailClearsMicrosoftLink: 'Saving unlinks Microsoft',
        externalPhoneField: 'Phone (optional)',
        externalBankAfterSave: 'Save this worker first to add a bank account. No account is saved yet.',
      },
      admin: {
        newUser: 'New user',
        levelName: { 'contractor-self-log': 'Contractor (logs own time)' },
        groupLabel: 'Group',
        accountLabel: 'Account',
        unsaved: 'unsaved',
        editUser: 'Edit {{name}}',
        draftBadge: 'New',
        addDraft: 'Add',
        removeDraft: 'Remove',
        usersLoadFailed: 'Could not load the users.',
        noFinanceSigner: 'No one can sign the finance stage, so annual leave stays Pending: give someone the CFO level. A person taking annual leave also needs the work type Full Time.',
        accessLevels: 'Access levels',
        accessLevelsHint: 'Permissions belong to a level, not to a person. Someone needs a different set? Create a level.',
        newLevel: 'New access level',
        levelAbilities: 'Abilities',
        levelLabel: 'Label',
        levelSlug: 'Slug',
        levelInUse: '{{n}} user(s) are on this level',
        nUsers: '{{n}} users',
        saveWithCount: 'Save {{n}} change(s)',
        discardChanges: 'Discard',
        confirmTitle: 'Confirm changes',
        emailMissing: 'Enter an email address.',
        emailInvalid: 'This is not an email address — check for a typo.',
        nothingToSave: 'There are no changes to save.',
        applyFailed: 'Not every change was applied; the list now shows what was saved.',
        viewAsFailed: 'Could not view as {{name}}.',
        inviteFailed: 'Could not invite {{email}}.',
        inviteResendFailed: 'Could not resend the invitation to {{email}}.',
        levelSaveFailed: 'Could not save the level “{{name}}”.',
        levelBasicRequired: 'Tick Basic as well: without it, this level’s other abilities open nothing.',
        levelDeleteFailed: 'Could not delete the level “{{name}}”.',
        levelLabelMissing: 'Enter a name for the level.',
        levelSlugMissing: 'Enter a slug for the level.',
        levelSlugInvalid: 'Start with a lowercase letter; use only lowercase letters, digits, - or _.',
        levelUnchanged: 'Nothing on this level has changed.',
        confirmApply: 'Apply {{n}} change(s)',
        changeName: 'name: {{from}} → {{to}}',
        changeLevel: 'access: {{from}} → {{to}}',
        changeActivated: 'activated',
        changeDeactivated: 'deactivated',
        changeCreated: 'new user ({{level}})',
        toggleActive: 'Toggle login access for {{name}}',
        changeDeactivateWithConsequence:
          'turns off login access — their work status in HR does not change; HR sets that',
        changeReactivateWithConsequence: 'turns on login access — their work status in HR does not change',
        inviteExternal: 'Invite external user',
        inviteTitle: 'Invite an external user',
        inviteHint:
          'Microsoft sends the invitation and owns the link, its expiry and the sign-in. The invitee reaches nothing until you give them an access level.',
        inviteSend: 'Send invitation',
        inviteSent: 'Invitation sent',
        inviteResent: 'Invitation resent',
        inviteResend: 'Resend',
        inviteNever: '—',
        invitePending: 'Sent, not signed in yet',
        inviteCopyLink: 'Copy link',
        inviteLinkCopied: 'Link copied',
        noAccessTitle: 'No access to CenTrig',
        noAccessBody:
          'You are signed in, but this account has not been given access. If you should have it, ask an administrator to grant your account access.',
        noAccessSignedInAs: 'Signed in as {{email}}',
        filterByLevel: 'Filter by level',
        allLevels: 'All levels',
        filterByType: 'Filter by type',
        allTypes: 'All types',
        notSet: 'Not set',
        rosterColumn: 'Roster',
        rosterManagerNote: 'Roster manager is ticked per person on the roster People page.',
        rosterManagerNoteLink: 'Go to People',
        inventoryColumn: 'Inventory',
        usernameColumn: 'Username',
        rosterManager: 'Manager',
        rosterStaff: 'Staff',
        rosterPerson: 'Roster person',
        showingCount: 'Showing {{n}} of {{total}}',
        clearFilters: 'Show all',
        noUsersMatchFilters: 'No users match these filters',
        noUsersMatchSearch: 'No users match “{{q}}”',
        sortBy: 'Sort by {{column}}',
        // The three ready filters, the fourth catch-all, and what
        // this page says about a person who has no login at all.
        filterByAccount: 'Filter by account',
        accountWithAccount: 'With an account',
        accountEveryone: 'Everyone (including no account)',
        filterByGroup: 'Filter by group',
        allGroups: 'Everyone',
        groupFullTime: 'Our full-time people',
        groupStaffOther: 'Our other people',
        groupExternal: 'Other-company roster',
        groupUnaffiliated: 'No HR record',
        noAccount: 'No account',
        grantAccountHint: 'Pick an access level to give this person an account',
        changeGrantAccount: 'Create an account at {{level}}',
        // ⛔ Says what is NOT tracked rather than implying something is. The
        // expiry column does not exist yet; until it does, nothing on this page can
        // enforce or show an end date, so this must not suggest one.
        noExternalsHere:
          'Nobody from an outside company is on the roster yet. They are added under Roster → People. They get no login here: any access arranged for them is temporary, and this page does not track when it ends.',
        // The ability catalogue is defined in the backend (`core/permissions.py`);
        // its labels are translated here and keyed by the ability KEY, which is what the
        // database stores -- so nothing below renames, merges or removes a grant.
        // `AdminUsers.tsx` falls back to the API label if a key here is missing.
        abilityGroup: {
          hr: 'People',
          pay: 'Pay',
          approvals: 'Approvals',
          time: 'Time & leave',
          roster: 'Roster',
          admin: 'Administration',
          other: 'Not yet grouped',
        },
        abilityName: {
          basic: 'Basic',
          self_log: 'Self log',
          staff: 'Staff',
          hr_view: 'View HR records',
          hr_extra: 'Personal record extras',
          hr_edit: 'Edit HR',
          staff_lifecycle_notify: 'Join and leave notices',
          salary_view: 'View pay',
          payroll: 'Payroll',
          activity_fund_edit: 'Activity fund',
          sales_invoice: 'Sales invoices',
          sales_sign_as_other: 'Sign as another invoicer',
          requests_approve: 'Approve requests',
          signoff_ceo: 'Approve as CEO',
          signoff_cfo: 'Approve as CFO',
          time_admin: 'Time admin',
          calendar_edit: 'Calendar editor',
          leave_admin: 'Leave admin',
          roster_plan: 'Roster manager',
          admin_elevate: 'Temporary admin',
          admin: 'Admin',
          roster_self: 'Own roster',
          public_view: 'Public view',
        },
        abilityHelp: {
          basic: 'Dashboard, the Organization chart and company calendar events; with an account, My Panel',
          self_log: 'Log your own time, book a hot desk, apply for leave',
          staff: "Sales quotations, requests, trips, clients and the price list, colleagues' profiles, the activity fund, and who is on leave in the calendar",
          hr_view: 'Read the personnel list, history and HR dashboard tiles (read-only)',
          hr_extra: 'See registration no, months before, contract end, dependent children and notes',
          hr_edit: 'Edit personnel records, pay rates, bank accounts and org-chart roles',
          staff_lifecycle_notify: 'Be emailed when someone joins or leaves, for social insurance',
          salary_view: 'Read pay rates and the salary run (read-only)',
          payroll: 'Run, close and issue payroll, set company rates and task rules, close out resignations, edit company bank accounts, pay trips, see every request and sales document',
          activity_fund_edit: 'Record activity fund income and expense',
          sales_invoice: 'Create and issue sales invoices, and act on anyone’s sales documents',
          sales_sign_as_other: 'Print another invoice holder’s signature instead of your own on a sales PDF',
          requests_approve: 'Approve reimbursement, purchase and trip requests',
          signoff_ceo: 'Sign the CEO stage',
          signoff_cfo: 'Sign the CFO stage, including the finance stage of leave',
          time_admin: "Correct anyone's time logs (including past ones within the payroll window) and activities",
          calendar_edit: "Add and remove holidays, copy last year's calendar and confirm a year; pay cut-offs follow the change",
          leave_admin: 'Administer leave and balances; issue a one-time pass through the leave block',
          roster_plan: 'Plan and edit every roster tab (roster staff only)',
          admin_elevate: 'Grant yourself admin for up to 8 hours, with a reason recorded',
          admin: 'Manage accounts, access levels and automated reminders',
          roster_self: 'See your own roster schedule',
          public_view: 'The dashboard, the company calendar and the org chart, nothing personal',
        },
        levelSpecial: 'Special abilities',
        impliedBy: 'Included with {{name}}',
        notHeld: 'Only an administrator grants an ability you do not hold',
        fixedLevel: 'Fixed setting: this level cannot be edited.',
        editInHr: 'Edit in HR',
        readOnlyNotice: 'Name comes from HR — open the HR record to change it.',
        viewAs: 'View as',
        viewingAs: 'Now viewing as {{name}}',
        viewingAsBanner: 'Viewing as {{name}} ({{email}}) — writes are blocked',
        exitViewAs: 'Exit',
        identityAction: 'Microsoft identity',
        identityTitle: 'Microsoft identity',
        identityLoadFailed: 'Could not read the linked identity, so no change can be made.',
        identityLinked: 'Linked to a Microsoft identity',
        identityUnlinked: 'Not linked to a Microsoft identity',
        identityOid: 'Object ID',
        identityEmail: 'Address',
        identityReplaceLabel: 'New object ID',
        identityReplaceHint: 'Look both IDs up in Entra first. A renamed account is not a re-link.',
        identityReplace: 'Replace…',
        identityClear: 'Clear binding…',
        identityClearHint: 'Clearing lets the next sign-in by this address bind a new identity.',
        identityInvalid: 'That is not a valid object ID (a UUID).',
        identitySame: 'That is the identity already linked.',
        identityReplaceMissing: 'Paste the new object ID first.',
        identityConfirmReplace: 'Replace the linked identity with {{oid}}? Sign-in as the old identity will stop working.',
        identityConfirmClear: 'Clear the binding? The next sign-in by this address will bind whichever identity signs in.',
        identityConfirm: 'Confirm',
        identityBack: 'Back',
        identityClose: 'Close',
        identityDoneReplaced: 'Identity replaced',
        identityDoneCleared: 'Binding cleared',
        identityRefNotFound: 'This person has no account any more.',
        identityRefAdminOnly: 'Only an administrator may re-link an administrator.',
        identityRefSelf: 'You cannot re-link your own identity.',
        identityRefNotLinked: 'This account is not linked, so there is nothing to re-link. Reload to see its current state.',
        identityRefStale: 'The linked identity changed since you opened this. Reload and check it again.',
        identityRefSameOid: 'That is the identity already linked.',
        identityRefTaken: 'That identity is already linked to {{holder}}.',
        identityRefInvalid: 'The request was refused as invalid.',
      },
  },
  ru: {
      clBonus: {
        title: 'Бонусные дни отгула',
        intro: 'Каждому оплачивается {{days}} дня отгула (CL) в год. Лучшему сотруднику года можно начислить дополнительные оплачиваемые дни на один календарный год. Учитывается в расчёте зарплаты; остатки отпусков не меняются.',
        loadFailed: 'Не удалось загрузить бонусные дни',
        paidThisYear: 'Оплачиваемый CL в {{year}}: {{days}} дн.',
        none: 'Бонусные дни не начислены.',
        year: 'Год', extraDays: 'Доп. дни', note: 'Примечание', grantedBy: 'Начислил',
        grant: 'Начислить', replace: 'Заменить', revoke: 'Отозвать',
        replaceConfirm: 'Заменить бонус за {{year}}?',
        revokeConfirm: 'Отменить бонус за {{year}}? Оплачиваемый CL за этот год снова составит 3 дня.',
        saved: 'Бонусные дни сохранены', revoked: 'Бонусные дни отменены',
        saveFailed: 'Не удалось сохранить',
        badYear: 'Введите год от 2000 до 2100',
        badDays: 'Введите больше 0 и не более 365 дней',
        halfDays: 'Только целые или половинные дни',
      },
      hr: {
        orgTabDirectory: 'Справочник', orgTabChart: 'Оргструктура', orgTabsLabel: 'Разделы организации', orgDirectoryEmpty: 'Сотрудники не найдены', directoryLoadFailed: 'Не удалось загрузить список сотрудников. Попробуйте ещё раз позже.', statusInactive: 'Неактивен', orgStatsHeading: 'Показатели компании', genderNotRecorded: 'Не указан', orgStatsLoadFailed: 'Не удалось загрузить показатели компании.', searchStaff: 'Поиск сотрудников',
        orgFilterShowing: 'Показано: {{name}}', orgFilterCount: '{{count}} из {{total}}', orgFilterClear: 'Сбросить фильтр', orgFilterNone: 'В этой выборке никого нет', orgFilterHint: 'Нажмите на команду или продукт, чтобы отфильтровать схему',
        name: 'Имя', staffId: 'Табельный номер', staffIdField: 'Табельный номер', staffCode: 'Код сотрудника',
        supervisor: 'Руководитель', peer: 'Заместитель', team: 'Команда', workType: 'Тип занятости',
        workCondition: 'Условия труда', position: 'Должность', positionMn: 'Должность (МН)', positionZh: 'Должность (КИТ)',
        contractEnd: 'Окончание договора', phone: 'Телефон', email: 'Рабочая почта', personalEmail: 'Личная почта',
        displayName: 'Отображаемое имя', firstName: 'Имя', lastName: 'Фамилия', firstNameMn: 'Имя (кириллица)', lastNameMn: 'Фамилия (кириллица)',
        office: 'Офис', status: 'Статус', dob: 'Дата рождения', gender: 'Пол', genderBlank: '—', genderMale: 'Мужской', genderFemale: 'Женский', country: 'Страна', degree: 'Образование', profession: 'Профессия',
        emergencyName: 'Экстренный контакт', emergencyPhone: 'Экстренный телефон',
        specialNeeds: 'Особые потребности', dependentChildren: 'Дети на иждивении', workedSince: 'Работает с', fullTimeStart: 'Полная занятость с', monthsBefore: 'Месяцев страхового стажа до приёма',
        workedSinceHelp: 'Первый рабочий день. При приёме или повторном приёме с него открывается запись о периоде работы, и шесть месяцев до первого начисления ежегодного отпуска считаются с этого дня. В зарплате это дата начала работы; она указывается в запросе юристам на регистрацию нового сотрудника в соцстрахе, и от неё считаются годовщины работы. Изменение этой даты сдвигает начало текущей записи о периоде работы.',
        fullTimeStartHelp: 'День перехода на полную занятость; если пусто, берётся дата начала работы. От него считаются стаж для ежегодного отпуска и ежегодное обнуление отгулов и больничных, а зарплата учитывает праздники сотрудника на полной занятости только с этой даты. Изменение этой даты сдвигает дату полной занятости в текущей записи о периоде работы.',
        monthsBeforeHelp: 'Месяцы социального страхования до приёма. Ступень ежегодного отпуска складывает их с месяцами полной занятости здесь до апреля 2026 года и с каждым месяцем с мая 2026 года, в котором из выданной зарплаты удержан соцстрах; завершённый месяц, зарплата за который ещё не выдана, учитывается, пока она не выдана. Другие расчёты это поле не используют.',
        resignationDate: 'Дата увольнения',
        resignationDateRequired: 'Укажите дату увольнения, чтобы сделать сотрудника неактивным',
        fieldRequired: 'Обязательное поле',
        workedSinceRequired: 'Укажите дату начала работы, чтобы сотрудник оставался активным',
        finalPay: {
          title: 'Окончательный расчёт',
          hint: 'Выберите, как был произведён окончательный расчёт и выплата этому сотруднику, и добавьте комментарий.',
          paid: 'Выплачено',
          next_payroll: 'Будет выплачено в следующей итоговой ведомости',
          owed: 'Не выплачено: сохранить сумму долга',
          other: 'Другое: опишите в комментарии, как произведён расчёт',
          comment: 'Комментарий',
          required: 'Чтобы сделать сотрудника неактивным, выберите итог окончательного расчёта и добавьте комментарий',
        },
        reactivateUndoConfirm: 'Сотрудник {{name}} будет восстановлен как прежде: остатки отпусков и период работы не меняются, дата увольнения очищается. Отпуска, отменённые по дате увольнения в этом периоде работы, восстанавливаются вместе с отметкой об оплате. Если оформлены выплата за отпуск или расчёт по отпуску при увольнении, сохранение будет отклонено, пока их не аннулируют. Продолжить?',
        reactivateRehireConfirm: 'Сотрудник {{name}} будет принят повторно с {{date}}: начнётся новый период работы, а AL, CL и PSL начнутся с нуля. Продолжить?',
        reactivateRestored: 'Восстановлено заявок на отпуск: {{count}}',
        undoRefusedPayout: 'Отменённый отпуск пока нельзя вернуть: есть закрытие выплаты за отпуск со статусом {{status}} (дата увольнения {{date}}). Сначала аннулируйте его. Если деньги уже выплачены, примите сотрудника заново с новой датой начала.',
        undoRefusedSettlement: 'Отменённый отпуск пока нельзя вернуть: есть расчёт отпуска при увольнении со статусом {{status}} (запрошено дней: {{days}}). Сначала отклоните его. Если деньги уже выплачены, примите сотрудника заново с новой датой начала.',
        undoRefusedPaidOff: 'Отменённый отпуск пока нельзя вернуть: после деактивации отпуск отмечен как выплаченный ({{note}}). Сначала исправьте остаток вручную. Если деньги уже выплачены, примите сотрудника заново с новой датой начала.',
        reactivateNotRestored: 'Эти отменённые заявки пересекаются с отпусками, оформленными позже, поэтому остаются отменёнными. Проверьте их и при необходимости оформите заново вручную: {{list}}',
        deactivateWarnTitle: 'Сохранение изменит не только карточку сотрудника {{name}}. Прочитайте, прежде чем продолжить.',
        deactivateWarnSignIn: '• Вход: если он есть, будет отключён. В течение 90 дней после даты увольнения сотрудник сможет открывать только свои расчётные листки, затем доступ закроется полностью.',
        deactivateWarnRoster: '• График вахты: сотрудник будет показан как уволившийся, и его больше нельзя будет добавить в график.',
        deactivateWarnLeave: '• Отпуска: все заявки на отпуск, начинающиеся после {{date}}, включая ожидающие, отменяются, кроме ежегодного отпуска, уже оплаченного через зарплату. Одобренные дни возвращаются на остаток.',
        deactivateWarnUndo: 'Чтобы отменить, снова сделайте сотрудника активным с той же датой начала работы: вернутся вход и график, а также отпуска, отменённые в этом периоде работы, с отметкой об оплате и использованным исключением из правил отпуска. Отпуска, изменённые позже или пересекающиеся с оформленными позже, остаются отменёнными. Пока оформлены выплата за отпуск или расчёт по отпуску при увольнении, отмена отклоняется до их аннулирования. С новой датой начала это повторный приём, и AL, CL и PSL начинаются с нуля.',
        deactivateWarnDateOnly: 'Перенос этой даты на более позднюю или её удаление не вернут отменённые отпуска: их нужно оформить заново вручную.',
        formerEmployee: '(бывший сотрудник)',
        sectionPersonal: 'Личные данные', sectionJob: 'Работа', sectionContact: 'Контакты', sectionOther: 'Прочее',
        attachLogin: 'Привязать к учётной записи', attachLoginNone: 'Новая запись (без привязки)', attachLoginHint: 'Учётные записи с входом по логину и паролю, без связи с Microsoft и без карточки сотрудника. При привязке e-mail не требуется.', sameNameWarning: 'Человек с таким именем уже есть в списке: {{names}}. Убедитесь, что вы не создаёте дубликат.',
        leaverTitle: 'Ваша работа в компании завершена',
        leaverBody:
          'В этой учётной записи теперь доступны только ваши собственные расчётные листы. Доступ закроется через 90 дней после даты увольнения — пожалуйста, скачайте то, что вам нужно. Ничего не удалено: отдел кадров и бухгалтерия сохраняют эти записи бессрочно.',
        leaverSignedInAs: 'Вы вошли как {{email}}',
        personalDataHidden: 'Скрыто: архивная запись',
        employeeLoadFailed: 'Не удалось загрузить карточку сотрудника',
        extrasHidden: 'Скрыто: нужно право «Дополнительные данные личного дела»',
        erasePii: 'Удалить личные данные', erasePiiConfirm: 'Удалить телефон, дату рождения, личную почту и другие личные данные этого человека? Это действие необратимо.', erasePiiDone: 'Персональные данные удалены',
        notes: 'Примечания',
        registrationNo: 'Регистрационный номер',
        registrationNoInvalid: 'Регистрационный номер: 2 кириллические буквы и 8 цифр, например УБ12345678.',
        allTeams: 'Все команды', showInactive: 'Показать неактивных', downloadExcel: 'Скачать Excel',
        downloaded: 'Скачано сотрудников: {{count}} (Excel).', downloadFailed: 'Не удалось создать файл Excel.', directorySheet: 'Справочник',
        newEmployee: 'Новый сотрудник', empty: 'Сотрудники не найдены', saved: 'Сохранено', savedTeams: 'Команды сохранены', savedSalary: 'Оплата сохранена', emailNeededForSignIn: 'Этот человек входит через этот адрес, поэтому его нельзя оставить пустым. Укажите другой адрес.',
        contractLegend: 'Договор', legendExpired: 'Истёк', legendSoon: 'В течение месяца', legendWatch: 'В течение трёх месяцев',
        tabGeneral: 'Общее', tabTeams: 'Команды', tabSalary: 'Оплата',
        saveGeneral: 'Сохранить общее', saveTeams: 'Сохранить команды', saveSalary: 'Сохранить оплату',
        entity: 'Юрлицо TRG', nobodyAssigned: 'Никто не назначен',
        viewReporting: 'Подчинённость', viewTeams: 'Команды', viewProducts: 'Продукты и услуги',
        chainAbove: 'Подчиняется', noSupervisor: 'Нет руководителя', expand: 'Развернуть', collapse: 'Свернуть',
        directReports: 'Подчинённые', fullRecordRestricted: 'Для просмотра полной записи нужен доступ HR',
        openRecord: 'Открыть', showLess: 'Свернуть', clearFilter: 'Сбросить фильтр',
        peopleShown: '{{count}} сотрудников',
        rateEditDate: 'Изменить дату начала', rateNewDate: 'Новая дата начала', rateSaveDate: 'Сохранить дату', rateCancel: 'Отмена',
        rateDelete: 'Удалить эту строку', rateDeleteConfirm: 'Удалить строку оплаты, действующую с {{date}}?',
        rateMoved: 'Дата начала изменена', rateDeleted: 'Строка оплаты удалена',
        rateDateTaken: 'Другая строка уже начинается с этой даты.',
        rateLocked: 'Выданная ведомость уже рассчитала {{day}} по этой ставке. Использованную ставку можно менять только с {{floor}}.',
        nothingToSave: 'Изменений пока нет',
        rateLockLoading: 'Проверяются закрытые месяцы',
        rateDateUnchanged: 'Выберите дату, отличную от текущей',
        rateLockedRow: 'Использована в выданной ведомости, удалить нельзя. Добавьте новую ставку с {{floor}} или позже.',
        rateSocLocked: 'Это изменение меняет код соцстрахования за {{month}} с {{from}} на {{to}}, а выданная ведомость его уже сохранила. Использованную ставку можно менять только с {{floor}}.',
        rateSocNone: 'нет',
        periodsTitle: 'Расчётные периоды',
        periodsHint: 'Расчёты этого сотрудника. Нажмите период, чтобы увидеть, из чего он сложился при выдаче.',
        periodsNone: 'Расчётов по этому сотруднику пока нет.',
        periodsLoadFailed: 'Не удалось загрузить расчётные периоды',
        periodAdvance: 'Аванс',
        periodFinal: 'Окончательный',
        periodDraft: 'Черновик',
        periodDraftNote: 'Ещё не выдан: черновик пересчитывается в Зарплате на лету, поэтому здесь ничего не зафиксировано и сумма не показывается.',
        periodTotalsOnly: 'Выдан до того, как расчёт стал фиксироваться: сохранены только итоги.',
        periodMeta: 'Отсечка {{cut}} · {{days}} · {{hours}} ч · оплата {{status}}',
        periodSpan: 'Дни',
        periodHours: 'Часы',
        periodTasks: 'Задачи',
        periodCarried: 'перенесено',
        periodDayHours: 'Часы по дням: {{days}} дн., введено {{entered}} ч, засчитано {{allowed}} ч',
        periodDayHoursNotRecorded: 'Часы по дням не записывались, когда этот расчёт был выдан.',
        periodNotRecorded: 'Не записано',
        periodDaysCount: '{{count}} дн.',
        periodGross: 'Начислено',
        periodAllowance: 'Надбавка',
        periodBonus: 'Премия',
        periodDeduction: 'Удержание',
        periodSocial: 'Соцстрахование',
        periodTax: 'НДФЛ',
        periodNet: 'К выплате',
        periodAdvancePaid: 'Выплаченный аванс',
        periodAdvanceAdjustment: 'Корректировка аванса',
        periodNetAdjustment: 'Корректировка чистой суммы',
        periodPayable: 'К выплате',
        rateFrozenMonths: 'Затронуты закрытые или выплаченные месяцы: {{months}}. Их оплата не пересчитывается.',
        rateHistory: 'История оплаты', noRates: 'Оплата не задана', currentRate: 'Текущая',
        estimatedMonthly: 'Расчётный месячный эквивалент: {{amount}}', estimatedMonthlyNote: 'при 8 ч × 260 дней',
        dailyRate: 'Дневная ставка', hourlyRate: 'Почасовая ставка', hourlyRateRequired: 'Укажите почасовую ставку.', effectiveSince: 'Действует с', rateType: 'Основа оплаты', payBasis: { hourly: 'Почасовая', daily: 'Подневная', fixed: 'Оклад', dailyHourly: 'Подневная + почасовая', choose: 'Выберите…' }, payBasisRequired: 'Перед сохранением выберите основу оплаты (почасовая, подневная или оклад).', rateGapNote: { effective_since: 'Не указана дата начала действия.', type_of: 'Не указана основа оплаты.', rate: 'Ставка пуста или равна 0. Проверьте, так ли задумано.', soc_ins_code: 'Не указан код социального страхования.' }, rateGapName: { effective_since: 'дата начала', type_of: 'основа оплаты', rate: 'ставка', soc_ins_code: 'соцстрахование' }, rateIncomplete: 'Неполная ставка: {{fields}}', noPayRate: 'Нет ставки', unratedLogged: 'Дней, записанных до {{before}}, которые не будут оплачены: {{count}} ({{dates}})', columns: 'Столбцы', columnsReset: 'Столбцы по умолчанию', columnsSaveStaffDefault: 'Сделать по умолчанию для сотрудников', columnsSaveStaffDefaultHint: 'Их видят те, у кого нет доступа к кадровым записям и кто не выбрал свои столбцы. Столбцы записей и зарплаты не сохраняются.', columnsSaveHrDefault: 'Сделать по умолчанию для HR', columnsSaveHrDefaultHint: 'Их видят те, у кого есть доступ к кадровым записям и кто не выбрал свои столбцы. Столбцы зарплаты видны только тем, кому она доступна.', columnsDefaultSaved: 'Столбцы по умолчанию сохранены', columnGroup: { directory: 'Справочник', record: 'Личное дело', salary: 'Текущая ставка' }, rateIncompleteColumn: 'Ставка заполнена не полностью', bankAccountColumn: 'Банковский счёт', rate: 'Ставка', taskRate: 'Ставка за задание',
        additional: 'Надбавка',
        socIns: 'Код соцстрахования', transitAdd: 'Транспортная надбавка',
        transitNoneDailyHourly: 'Транспортная надбавка: нет при ставке день+час; журнал подрядчика оплачивает только дни и часы.',
        taskRuleSet: 'Набор правил заданий',
        taskRuleSetNone: '— нет (фиксированная ставка)',
        taskRateNotUsed: 'Выбран набор правил, поэтому фиксированная ставка за задание не используется.',
        socInsTaxExempt: 'без налога',
        workConditionNormal: 'Обычные',
        workConditionSpecial: 'Особые',
        personalEmailInvalid: 'Личный email указан неверно, например bat@gmail.com.',
        phoneInvalid: 'Номер телефона содержит только цифры, в начале может быть +.',
        rateVersionNote: 'Изменение ставки, надбавки или кода соцстрахования создаёт новую версию. Прочие изменения правят текущую.',
        // Under the account field; see lib/accountStatus.ts.
        
        
        // The salary bank accounts -- up to three, one of them
        // primary. `hr.account` above is the LEGACY single field on the pay
        // rate and is deliberately left where it is; these keys belong to the
        // new per-person table.
        bank: {
          title: 'Банковские счета',
          add: 'Добавить счёт',
          primaryNote: 'Зарплата перечисляется только на основной счёт. Остальные хранятся для информации.',
          empty: 'Банковских счетов нет',
          loadFailed: 'Не удалось загрузить банковские счета',
          noPrimaryWarning: 'Ни один из них не отмечен как зарплатный, поэтому сотрудник не попадёт в файл перевода. Выберите один.',
          primary: 'Зарплатный счёт',
          atCap: 'У сотрудника может быть не более {{max}} счетов. Удалите один, чтобы добавить новый.',
          saved: 'Банковский счёт сохранён',
          removed: 'Банковский счёт удалён',
          bankName: 'Банк',
          choose: 'Выберите банк',
          accountNumber: 'Номер счёта (IBAN)',
          accountName: 'Владелец счёта',
          accountNameHint: 'Имя, на которое счёт открыт в банке, если оно отличается.',
          bankRequired: 'Выберите банк',
          numberRequired: 'Введите номер счёта',
          shapeHint: 'Монгольский номер счёта — 20 символов: MN и 18 цифр.',
          codeMismatch: 'Этот номер принадлежит другому банку, чем выбранный. Проверьте оба.',
          makePrimary: 'Сделать зарплатным счётом',
          forcedPrimary: 'Это зарплатный счёт — единственный в записи.',
          selfNote: 'Вы можете добавлять, изменять и удалять другие свои счета. Основной зарплатный счёт выбирает и меняет только отдел кадров.',
          selfNoPrimary: 'Отдел кадров ещё не выбрал ваш основной зарплатный счёт. Обратитесь в отдел кадров, чтобы зарплату можно было перечислить.',
        },
        roleHistory: 'История ролей', roleHistoryEmpty: 'История не найдена', roleHistoryBaseline: 'Начальная точка',
        roleHistoryUnassigned: 'Не назначено', productRetired: '(выведен)', roleHistorySince: 'с {{date}}',
        recordTrail: 'След записи',
        recordCreatedBy: 'Создал',
        recordUpdatedBy: 'Последним изменил',
        recordNoActor: 'Импортировано — пользователь не записан',
        recordUnknownActor: 'Неизвестный пользователь',
        externalNew: 'Новый внешний работник',
        externalNameRequired: 'Введите имя',
        externalCompanyRequired: 'Введите компанию',
        externalFillFirst: 'Сначала заполните поля, отмеченные звёздочкой (*)',
        externalsLoadFailed: 'Не удалось загрузить внешних работников',
        externalEditTitle: 'Редактировать внешнего работника',
        externalViewTitle: 'Внешний работник',
        externalEmailField: 'Эл. почта (необязательно)',
        externalEmailRequiredField: 'Эл. почта',
        emailLockAdminOnly: 'Изменить эл. почту может только администратор или тот, кто управляет пользователями',
        emailLockOwn: 'Вы не можете изменить свою эл. почту',
        emailLockAdminTarget: 'Эл. почту учётной записи выше участника может изменить только администратор',
        emailClearsMicrosoftLink: 'Сохранение отвяжет Microsoft',
        externalPhoneField: 'Телефон (необязательно)',
        externalBankAfterSave: 'Сначала сохраните работника, чтобы добавить банковский счёт. Счёт пока не сохранён.',
      },
      admin: {
        newUser: 'Новый пользователь',
        levelName: { 'contractor-self-log': 'Подрядчик (сам отмечает время)' },
        groupLabel: 'Группа',
        accountLabel: 'Учётная запись',
        unsaved: 'не сохранено',
        editUser: 'Изменить: {{name}}',
        draftBadge: 'Новый',
        addDraft: 'Добавить',
        removeDraft: 'Убрать',
        usersLoadFailed: 'Не удалось загрузить пользователей.',
        noFinanceSigner: 'Некому подписать финансовый этап, поэтому ежегодный отпуск останется в ожидании: назначьте кому-нибудь уровень CFO. Для ежегодного отпуска у сотрудника также должен быть тип работы Full Time.',
        accessLevels: 'Уровни доступа',
        accessLevelsHint: 'Права принадлежат уровню, а не человеку. Нужен другой набор — создайте уровень.',
        newLevel: 'Новый уровень доступа',
        levelAbilities: 'Права',
        levelLabel: 'Название',
        levelSlug: 'Идентификатор',
        levelInUse: 'На этом уровне пользователей: {{n}}',
        nUsers: 'пользователей: {{n}}',
        saveWithCount: 'Сохранить ({{n}})',
        discardChanges: 'Отменить',
        confirmTitle: 'Подтвердите изменения',
        emailMissing: 'Введите адрес электронной почты.',
        emailInvalid: 'Это не адрес электронной почты — проверьте опечатку.',
        nothingToSave: 'Нет изменений для сохранения.',
        applyFailed: 'Применены не все изменения; список показывает, что сохранено.',
        viewAsFailed: 'Не удалось войти от имени {{name}}.',
        inviteFailed: 'Не удалось пригласить {{email}}.',
        inviteResendFailed: 'Не удалось повторно отправить приглашение на {{email}}.',
        levelSaveFailed: 'Не удалось сохранить уровень «{{name}}».',
        levelBasicRequired: 'Отметьте также «Базовый»: без него остальные права этого уровня ничего не открывают.',
        levelDeleteFailed: 'Не удалось удалить уровень «{{name}}».',
        levelLabelMissing: 'Введите название уровня.',
        levelSlugMissing: 'Введите идентификатор уровня.',
        levelSlugInvalid: 'Начните со строчной латинской буквы; допустимы строчные буквы, цифры, - и _.',
        levelUnchanged: 'В этом уровне ничего не изменено.',
        confirmApply: 'Применить ({{n}})',
        changeName: 'имя: {{from}} → {{to}}',
        changeLevel: 'доступ: {{from}} → {{to}}',
        changeActivated: 'активирован',
        changeDeactivated: 'деактивирован',
        changeCreated: 'новый пользователь ({{level}})',
        toggleActive: 'Переключить доступ для входа — {{name}}',
        changeDeactivateWithConsequence:
          'отключает доступ для входа — рабочий статус в HR не меняется, его устанавливает HR',
        changeReactivateWithConsequence: 'включает доступ для входа — рабочий статус в HR не меняется',
        inviteExternal: 'Пригласить внешнего пользователя',
        inviteTitle: 'Приглашение внешнего пользователя',
        inviteHint:
          'Приглашение отправляет Microsoft: ссылка, её срок и вход — на их стороне. Приглашённый не получит доступа, пока вы не назначите уровень.',
        inviteSend: 'Отправить приглашение',
        inviteSent: 'Приглашение отправлено',
        inviteResent: 'Приглашение отправлено повторно',
        inviteResend: 'Отправить снова',
        inviteNever: '—',
        invitePending: 'Отправлено, вход не выполнен',
        inviteCopyLink: 'Копировать ссылку',
        inviteLinkCopied: 'Ссылка скопирована',
        noAccessTitle: 'Нет доступа к CenTrig',
        noAccessBody:
          'Вы вошли в систему, но этой учётной записи не предоставлен доступ. Если доступ вам нужен, обратитесь к администратору.',
        noAccessSignedInAs: 'Вы вошли как {{email}}',
        filterByLevel: 'Фильтр по уровню',
        allLevels: 'Все уровни',
        filterByType: 'Фильтр по типу занятости',
        allTypes: 'Все типы',
        notSet: 'Не указано',
        rosterColumn: 'График смен',
        rosterManagerNote: 'Менеджер графика отмечается для каждого человека на странице «Люди» графика.',
        rosterManagerNoteLink: 'Открыть «Люди»',
        inventoryColumn: 'Инвентарь',
        usernameColumn: 'Имя пользователя',
        rosterManager: 'Менеджер графика',
        rosterStaff: 'Сотрудник графика',
        rosterPerson: 'В графике',
        showingCount: 'Показано {{n}} из {{total}}',
        clearFilters: 'Показать все',
        noUsersMatchFilters: 'Нет пользователей, соответствующих этим фильтрам',
        noUsersMatchSearch: 'Нет пользователей по запросу «{{q}}»',
        sortBy: 'Сортировать по: {{column}}',
        // The three ready filters, the fourth catch-all, and what
        // this page says about a person who has no login at all.
        filterByAccount: 'Фильтр по учётной записи',
        accountWithAccount: 'С учётной записью',
        accountEveryone: 'Все (включая без учётной записи)',
        filterByGroup: 'Фильтр по группе',
        allGroups: 'Все люди',
        groupFullTime: 'Наши сотрудники на полной занятости',
        groupStaffOther: 'Наши прочие сотрудники',
        groupExternal: 'Реестр сторонних компаний',
        groupUnaffiliated: 'Нет кадровой записи',
        noAccount: 'Нет учётной записи',
        grantAccountHint: 'Выберите уровень доступа, чтобы создать учётную запись',
        changeGrantAccount: 'Создать учётную запись с уровнем «{{level}}»',
        noExternalsHere:
          'Сотрудников сторонних компаний в реестре пока нет. Их добавляют в разделе «График вахты → Люди». Учётную запись здесь они не получают: любой предоставленный им доступ является временным, и эта страница не отслеживает, когда он заканчивается.',
        // The ability catalogue is defined in the backend (`core/permissions.py`);
        // its labels are translated here and keyed by the ability KEY, which is what the
        // database stores -- so nothing below renames, merges or removes a grant.
        // `AdminUsers.tsx` falls back to the API label if a key here is missing.
        abilityGroup: {
          hr: 'Сотрудники',
          pay: 'Зарплата',
          approvals: 'Утверждения',
          time: 'Время и отпуск',
          roster: 'График смен',
          admin: 'Администрирование',
          other: 'Без группы',
        },
        abilityName: {
          basic: 'Базовый',
          self_log: 'Свой учёт',
          staff: 'Сотрудник',
          hr_view: 'Просмотр кадровых записей',
          hr_extra: 'Доп. личные данные',
          hr_edit: 'Редактирование HR',
          staff_lifecycle_notify: 'Уведомления о приёме и увольнении',
          salary_view: 'Просмотр зарплаты',
          payroll: 'Расчёт зарплаты',
          activity_fund_edit: 'Фонд мероприятий',
          sales_invoice: 'Счета на продажу',
          sales_sign_as_other: 'Подпись другого сотрудника',
          requests_approve: 'Утверждение заявок',
          signoff_ceo: 'Утверждать как CEO',
          signoff_cfo: 'Утверждать как CFO',
          time_admin: 'Администратор времени',
          calendar_edit: 'Редактор календаря',
          leave_admin: 'Администратор отпусков',
          roster_plan: 'Менеджер графика',
          admin_elevate: 'Временный админ',
          admin: 'Администратор',
          roster_self: 'Свой график',
          public_view: 'Публичный просмотр',
        },
        abilityHelp: {
          basic: 'Панель, оргструктура и события календаря компании; с учётной записью — Моя панель',
          self_log: 'Учёт своего времени, бронирование рабочего места, заявка на отпуск',
          staff: 'Коммерческие предложения, заявки, командировки, клиенты и прайс-лист, профили коллег, фонд мероприятий и кто в отпуске в календаре',
          hr_view: 'Чтение списка сотрудников, истории и плиток HR на панели (только чтение)',
          hr_extra: 'Регистрационный номер, предыдущие месяцы, окончание договора, дети на иждивении и примечания',
          hr_edit: 'Редактирование кадровых записей, ставок, банковских счетов и ролей в оргструктуре',
          staff_lifecycle_notify: 'Письмо, когда кто-то принят или уволен, для соцстрахования',
          salary_view: 'Чтение ставок и расчёта зарплаты (только чтение)',
          payroll: 'Проведение, закрытие и выпуск расчёта зарплаты, ставки компании и правила задач, закрытие увольнений, банковские счета компании, оплата командировок, просмотр всех заявок и документов продаж',
          activity_fund_edit: 'Учёт доходов и расходов фонда мероприятий',
          sales_invoice: 'Создание и выставление счетов на продажу, действия с чужими документами продаж',
          sales_sign_as_other: 'Печатать вместо своей подпись другого сотрудника с правом выставлять счета в PDF документа продаж',
          requests_approve: 'Утверждение заявок на возмещение, закупку и командировку',
          signoff_ceo: 'Подпись этапа CEO',
          signoff_cfo: 'Подпись этапа CFO, включая финансовый этап отпуска',
          time_admin: 'Исправление учёта времени любого сотрудника (включая прошлый в пределах окна расчёта) и видов работ',
          calendar_edit: 'Добавление и удаление праздников, копирование календаря прошлого года и подтверждение года; даты отсечки зарплаты следуют за изменением',
          leave_admin: 'Управление отпусками и остатками; разовый пропуск через блокировку отпуска',
          roster_plan: 'Планирование и редактирование всех вкладок графика (только сотрудники графика)',
          admin_elevate: 'Выдать себе права администратора до 8 часов с записью причины',
          admin: 'Управление учётными записями, уровнями доступа и автоматическими напоминаниями',
          roster_self: 'Просмотр своего графика',
          public_view: 'Панель, календарь компании и оргструктура, без личных данных',
        },
        levelSpecial: 'Особые права',
        impliedBy: 'Входит в «{{name}}»',
        notHeld: 'Право, которого у вас нет, выдаёт только администратор',
        fixedLevel: 'Фиксированная настройка: этот уровень нельзя изменить.',
        editInHr: 'Изменить в HR',
        readOnlyNotice: 'Имя берётся из HR — откройте карточку в HR, чтобы изменить его.',
        viewAs: 'Смотреть как',
        viewingAs: 'Теперь вы смотрите как {{name}}',
        viewingAsBanner: 'Вы смотрите как {{name}} ({{email}}) — запись заблокирована',
        exitViewAs: 'Выйти из режима просмотра',
        identityAction: 'Учётная запись Microsoft',
        identityTitle: 'Учётная запись Microsoft',
        identityLoadFailed: 'Не удалось прочитать привязку, поэтому изменений делать нельзя.',
        identityLinked: 'Привязана к учётной записи Microsoft',
        identityUnlinked: 'Не привязана к учётной записи Microsoft',
        identityOid: 'ID объекта',
        identityEmail: 'Адрес',
        identityReplaceLabel: 'Новый Object ID',
        identityReplaceHint: 'Сначала найдите оба ID в Entra. Переименование учётной записи не является перепривязкой.',
        identityReplace: 'Заменить…',
        identityClear: 'Снять привязку…',
        identityClearHint: 'После снятия следующий вход по этому адресу привяжет новую учётную запись.',
        identityInvalid: 'Это не корректный Object ID (UUID).',
        identitySame: 'Эта учётная запись уже привязана.',
        identityReplaceMissing: 'Сначала вставьте новый Object ID.',
        identityConfirmReplace: 'Заменить привязку на {{oid}}? Вход под прежней учётной записью перестанет работать.',
        identityConfirmClear: 'Снять привязку? Следующий вход по этому адресу привяжет ту учётную запись, которая войдёт.',
        identityConfirm: 'Подтвердить',
        identityBack: 'Назад',
        identityClose: 'Закрыть',
        identityDoneReplaced: 'Привязка заменена',
        identityDoneCleared: 'Привязка снята',
        identityRefNotFound: 'У этого человека больше нет учётной записи.',
        identityRefAdminOnly: 'Администратора может перепривязать только администратор.',
        identityRefSelf: 'Нельзя перепривязать собственную учётную запись.',
        identityRefNotLinked: 'Учётная запись не привязана, перепривязывать нечего. Обновите страницу, чтобы увидеть текущее состояние.',
        identityRefStale: 'Привязка изменилась с момента открытия. Обновите и проверьте снова.',
        identityRefSameOid: 'Эта учётная запись уже привязана.',
        identityRefTaken: 'Эта учётная запись уже привязана к {{holder}}.',
        identityRefInvalid: 'Запрос отклонён как некорректный.',
      },
  },
}
